// Imports Angular
import { Component, OnInit, ViewEncapsulation, KeyValueDiffers, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material';

import 'rxjs/add/observable/forkJoin';

import { saveAs } from 'file-saver';

// Imports DIAN  
import { DContextoMuisca, DError, DLogger, DMessageObsService, DRespuestaSimple } from '@dian/core';
import { DFormulario, DOperacionesMatematicasServicio, DUtilidadesFormularioServicio, DTipoOperacionAritmetica, DDatosCompartidosCabecera } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DRenta210v18Servicios, DObjetoPagoPrimeraCuota, DRangosArt241ET, DDeclaracionSugerida } from '@dian-api/renta210v18'; //DObjetoEsResponsabilidad
import { DReciboPagoDialogoServicio } from '@dian-cmp/recibo-pago';
import { DArchivoBlob } from '@dian/api-formulario';
import { DRutServicios, DActividadesEconomicas } from '@dian/api-rut';
import { DDiligenciamientoParametricasServicios } from '@dian/api-diligenciamiento';
import { DPreguntasDialogoServicio } from '@dian-cmp/preguntas';
import { DBasicosParametricasServicios, DValorPeriodico, DValorDominio } from '@dian/api-basicos-parametricas';
import { DContextoUsuarioServicio } from '@dian/api-identidad';

// Imports App
import { DFormularioConfiguracion } from '../../../configuracion/dformulario-configuracion';
import { DPreguntasFormulario } from '../../../configuracion/dpreguntas-formulario';
import { DAyudasFormulario } from '../../../configuracion/dayudas-formulario';


import { DReciboPagoExteriorDialogoServicio } from '@dian-cmp/recibo-pago490-exterior';
import { GeneralDialogComponent } from '../../dialogos/general/general-dialog.component';
import { DialogsConfig } from '../../../configuracion/dialog-views-data';
import { Step } from '../../stepper/stepper.component';

import { NotificationsService } from '../../../services/notifications.service';
import { MessageObservableService } from '../../../services/message-observable.service';
import { DLiquidacionRecibo, DReciboPago490Servicios, DRtaLiquidacionReciboPago } from '@dian-api/recibo-pago490';
import { DDevolucionesServicios,DDilPersonaRutJSON } from '@dian-api/devoluciones';
import { SugeridaComponent } from '../../dialogos/sugerida/sugerida.component';
import { environment } from '../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { ClassGetter, THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { DSugeridaNubeServicios } from '@dian-api/sugerida-nube';
import { DevolucionesComponent } from '../../devoluciones/devoluciones.component';
import { Observable } from 'rxjs';

declare var require: (filename: string) => any;
var BigNumber210 = require('bignumber.js');

BigNumber210.config({
  DECIMAL_PLACES: 3,
  EXPONENTIAL_AT: 100,
  FORMAT: {
    groupSize: 3,
    groupSeparator: ',',
    decimalSeparator: '.'
  }
});

const optionsTabsFirma = [
  { text: 'Pregunta(s) inicial(es)' },
  { text: 'Formulario 210' },
  { text: 'Firmar' },
  { text: 'Presentar' },
  { text: 'Pagar' }
];

const optionsTabsSinFirma = [
  { text: 'Pregunta(s) inicial(es)' },
  { text: 'Formulario 210' },
  { text: 'Definitivo' },
  { text: 'Pagar' }
];

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Datos Declarante' },
  { text: "2", active: false, completed: false, tooltip: 'Deducción Imputable y beneficios tributarios sin limitantes' },
  { text: "3", active: false, completed: false, tooltip: 'Dependiente' },
  { text: "4", active: false, completed: false, tooltip: 'Patrimonio' },
  { text: "5", active: false, completed: false, tooltip: 'Rentas de trabajo.' },
  { text: "6", active: false, completed: false, tooltip: 'Rentas de trabajo que no provengan de una relación laboral o legal y reglamentaria' },
  { text: "7", active: false, completed: false, tooltip: 'Rentas de capital' },
  { text: "8", active: false, completed: false, tooltip: 'Rentas no laborales' },
  { text: "9", active: false, completed: false, tooltip: 'Cédula general' },
  { text: "10", active: false, completed: false, tooltip: 'Cédula de pensiones' },
  { text: "11", active: false, completed: false, tooltip: 'Cédula de dividendos y participaciones' },
  { text: "12", active: false, completed: false, tooltip: 'Cédula de dividendos y participaciones' },
  { text: "13", active: false, completed: false, tooltip: 'Ganancia ocasional' },
  { text: "14", active: false, completed: false, tooltip: 'Liquidación privada' },
  { text: "15", active: false, completed: false, tooltip: 'Pago total' }

];

//Filtros
const DOCS_FILTER = ['11', '12', '13', '14', '21', '22', '31', '32', '41', '42'];
const CARACTERSUGERIDA = 'c';
//Politicas
const POLITICA_109 = "109";
const POLITICA_1630 = "1630";
const POLITICA_1644 = "1644";
const POLITICA_1644_ORDER_FIELD = "codigo";
const POLITICA_1644_ORDER_TYPE = "asc";
const VAL_PERIODICO_110 = 110;
const POLITICA_318 = 318;
const HABILITA_DEVOLUCION = 'HABILITA_DEVOLUCION';
const TIPO_REG_DECLARACION_SUG = '60600001';
const TIPO_REG_DECLARACION_SUG_FACTURA_RENTA = '60600002';
const FORMATO = 210;

//Mensajes
const MESSAGE_ACTIVIDADES_ECONOMICAS_EMPTY = `Para continuar, es necesario completar las casillas 286 y 24 
  teniendo en cuenta su situación económica y los datos del RUT. Además, considere la nueva clasificación de 
  actividades económicas CIIU, adaptada para Colombia por la DIAN mediante las Resoluciones Nro. 000114 del 21 de diciembre de 2020 y Nro. 001232 del 16 de septiembre de 2022.`;
const MESSAGES = {
  FACTURA_NO_CORREGIBLE: "La Factura de Renta no puede ser corregida",
  DILIGENCIA_CAS24: "Para continuar, seleccione una actividad económica de la casilla 24.",
  ES_MAYOR: "Superó tope indicativo relativo al art. 336-1 del E.T. marque casilla 140",
  SUMATORIA_MAYOR_A_INGRESOS: "La sumatoria de los valores reportados en las preguntas no puede superar la suma de los ingresos (cas. 32 + cas. 43 + cas. 58 + cas. 74)",
  GENERO_OBLIGATORIO: "Diligencie el género seleccionando uno de los elementos en la lista de la casilla 286",
  TARIFA_DIVIDENDOS: "Señor Contribuyente: Para liquidar el impuesto de dividendos conforme al inciso 2 del artículo 242 del Estatuto Tributario diligencie una de las siguientes tarifas 0 %, 5 %, 9 %, 15 %, 27 %, 33 %, 35 %, 38 %, 40 %, 45 %, 50 %, 8.75 %, 17.5 % y 26.25 % que le aplicaron como retención en la fuente al momento del pago.",
  APORTE_VOLUNTARIO: "Su aporte voluntario se destinará para programas sociales de reducción de la pobreza extrema al igual que para programas de atención a las personas en condición de discapacidad física, priorizando así la población socioeconómica más vulnerable",
  PRESENTADO: "Estimado(a) ciudadano(a) <br><br>Gracias al pago de sus impuestos, el Estado puede financiar proyectos sociales y obras de infraestructura pública que nos benefician a todos.<br>Ratificamos nuestra intención de hacer de la DIAN una entidad más ágil, eficiente, cercana y moderna, que le ayude a cumplir, de mejor manera, sus obligaciones tributarias.<br>Juntos trabajamos para trasformar a Colombia.<br><br><b>Luis Carlos Reyes</b><br>Director General",
  DEPENDIENTE: "El dependiente asociado a la deducción del 10%, debe ser igual a uno de los agregados en las casillas 242,288,291 o 294"
};

@Component({
  selector: 'app-formulario',
  templateUrl: './formulario.component.html',
  styleUrls: ['./formulario.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    DContextoUsuarioServicio,
    DNotificacionServicio,
    DPreguntasDialogoServicio,
    DOperacionesMatematicasServicio,
    DUtilidadesFormularioServicio,
    DRenta210v18Servicios,
    DRutServicios,
    DDiligenciamientoParametricasServicios,
    DBasicosParametricasServicios,
    DReciboPagoExteriorDialogoServicio,
    DReciboPagoDialogoServicio,
    DReciboPago490Servicios,
    DSugeridaNubeServicios,
    DDevolucionesServicios,
  ]
})
export class FormularioComponent extends DFormulario implements OnInit {

  @ViewChild('focusable124') cas214Element: ElementRef;

  //Tab
  public optionsTabs: any[] = [];
  public indexSelectedTab: number = 0;

  //Preguntas Residente
  public tiempoPermanencia: string = "";
  public completoPeriodoPermanencia: string = "";
  public tieneNacionalidadColombiana: string = "";
  public servicioEstadoEnExterior: string = "";
  public ingresosJurisdiccionDomicilio: string = "";
  public activosJurisdiccionExterior: string = "";
  public esFamiliaResidenteFiscal: string = "";
  public ingresosFuenteNacional: string = "";
  public bienesAdministradosColombia: string = "";
  public activosPoseidosColombia: string = "";
  public noPuedeAcreditarResidenteExterior: string = "";
  public esResidenteParaisoFiscal: string = "";

  //Stepper
  public stepsList: Step[] = stepsList;
  public indexStepper: number = 0;
  public validarRespuestaCambioTab: boolean = false;
  public habilitarSiguienteEnFirma: boolean = false;
  public documentoFirmado: boolean = false;

  //Recibo de pago
  public liquidacionRecigoPago: DLiquidacionRecibo = new DLiquidacionRecibo();
  public aporteVoluntario: number;
  public reciboPago: DRtaLiquidacionReciboPago = new DRtaLiquidacionReciboPago();

  private tipoDeclaracion: boolean = true;
  private booFraccion: boolean = false;
  private booCorreccion: boolean = false;
  private booCas108: boolean = true;
  private booCas108Clic: boolean = false;
  private booModifi2023: boolean = false;
  private booTopeindicativo: boolean = false;


  // Variables  
  public ruta490: string = window.location.origin + '/WebDilIngresoFormReciboPago490';
  public ruta110: string = window.location.origin + '/WebDilIngresoFormRenta110';
  private UVT: string;
  private anioDeclaracion: number;
  private periodo: number;
  private cuentadependientes: number = 0;
  private parameters: any;
  private tiposDocumento: Array<DValorDominio>;
  private tiposDocumentofiltrado: Array<DValorDominio>;
  private boolfinal = false;
  ;
  private tiposParentesco;
  private listaGenero;
  private email;
  private strResponabilidad: string;
  private strHistoricoEstado: string;
  private personaRUTJSON: DDilPersonaRutJSON;

  //Declaración sugerida
  public declaracionSugerida: any;
  //public declaracionSugeridaTO: any;
  private tienePrimeraCuota: DObjetoPagoPrimeraCuota;
  //casillas casillasDinamicas
  private casillasDinamicas: any;
  //actividadesEconomicas
  //private listaActividadesEconomicas: DActividadesEconomicas;
  private listaActividadesEconomicasVigentes;
  //Rangos Articulo 241 Estatuto Tributario  
  private rangosArt241ET: any;
  private rangosArt241ETNumeral2: any;
  private rangosArt241ETInciso1: any;
  private tabla1: any;
  private tabla2: any;
  public esDecretoMocoa: boolean;
  public habilitaDevoluciones: boolean = false;
  private temporal41: string;
  private temporal53: string;
  private temporal69: string;
  private temporal86: string;

  private cambioFirma: boolean = true;
  //private contador: Number = 0;

  private tarifaA: string;
  private tarifaB: string;
  private strDividendosOtros: string;
  private porcDividendos = ['0', '5', '9', '15', '27', '33', '35', '38', '40', '45', '50', '8.75', '17.5', '26.25'];

  private calcularCas121: boolean = true;
  public mensajeIconoSugerida: string = 'Consultar Declaración sugerida';

  private dataHelps: any[] = [];

  habilitaDependiente2: boolean = false;
  habilitaDependiente3: boolean = false;
  habilitaDependiente4: boolean = false;
  habilitaDependiente5: boolean = false;
  //protected siModeloCambio: boolean=false;

  private disponibilidad : boolean = true;

  private stepsToSaveForm: number[] = [4, 9]; ///modificar 9
  private isFirstTime: boolean = true;

  constructor(
    dialog: MatDialog,
    router: Router,
    dNotificacionServicio: DNotificacionServicio,
    dPreguntasDialogoServicio: DPreguntasDialogoServicio,
    activatedRoute: ActivatedRoute,
    dutilidades: DOperacionesMatematicasServicio,
    utilitariosForm: DUtilidadesFormularioServicio,
    dlogger: DLogger,
    private dContextoUsuario: DContextoUsuarioServicio,
    private dRutServicios: DRutServicios,
    private dServicioRESTAPI: DRenta210v18Servicios,  // Servicio de ejemplo (debe ser cambiado por el del api del formulario correspondiente),
    private dServiciosDiliParametricas: DDiligenciamientoParametricasServicios,
    private dBasicosParametricasServicios: DBasicosParametricasServicios,
    private dReciboPago: DReciboPagoDialogoServicio,
    private dReciboPagoExteriorDialogoServicio: DReciboPagoExteriorDialogoServicio,
    differ: KeyValueDiffers,
    private _location: Location,
    private helps: DAyudasFormulario,
    private _notifications: NotificationsService,
    private _messagesObs: MessageObservableService,
    private _restPago: DReciboPago490Servicios,
    private _restDevolucion: DDevolucionesServicios,
    private _restSugeridaNube: DSugeridaNubeServicios,
    private el: ElementRef,
    private _coreMessagesObs: DMessageObsService
  ) {
    super(
      router,
      activatedRoute,
      dialog,
      dContextoUsuario,
      dNotificacionServicio,
      dPreguntasDialogoServicio,
      dutilidades,
      utilitariosForm,
      dRutServicios,
      dServicioRESTAPI,
      new DFormularioConfiguracion(),
      new DPreguntasFormulario(),
      dlogger,
      differ,
      dServiciosDiliParametricas,
      dReciboPago,
      _coreMessagesObs
    );


    this.dataHelps = helps.AYUDAS_FORMULARIO[0].ayudas;
    this.casillasDinamicas = {
      cs_id_980: { disabled: false },
      cs_id_95: { disabled: false }
    }
    this.tienePrimeraCuota = null;
    this.declaracionSugerida = null;
    this.rangosArt241ET = DRangosArt241ET.NUMERAL_1;
    this.rangosArt241ETNumeral2 = DRangosArt241ET.NUMERAL_2;
    this.rangosArt241ETInciso1 = DRangosArt241ET.INCISO_1;
    this.tabla1 = DRangosArt241ET.TABLA1;
    this.tabla2 = DRangosArt241ET.TABLA2;
    this.esDecretoMocoa = false;
  }

  ngOnInit() {
    setTimeout(() => this.consultarFirmanteElectronico('desconocido'), 50);     //Esta linea inicia todo el proceso de la clase abstracta    
    this.activatedRoute.queryParams
      .subscribe((params: Params) => this.parameters = params);
    this.listenMessagesObs();
    this.listenCoreMessagesObs();
  }

  protected onInitFormulario() {

    this.procesarSinNotificaciones = true; //Previene mostrar las notificaciones o precarga del guardado automatico
    this.optionsTabs = this.firmaRequerida ? optionsTabsFirma : optionsTabsSinFirma;
    this.anioDeclaracion = Number(this.modelo.doc.cab.cs_id_1);
    this.verificaDisponiblidad();
    this.periodo = Number(this.modelo.doc.cab.cs_id_3);
    this.modelo.doc.cab.cs_id_12 = Number(this.modelo.doc.cab.cs_id_12);
    this.modelo.doc.cuerpo.cs_id_303 = '0';
    //Se castea la variable boolean de la casilla 994
    if (!this.modelo.doc.pie.hasOwnProperty('cs_id_994') || this.modelo.doc.pie['cs_id_994'] == "false")
      this.modelo.doc.pie['cs_id_994'] = false;
    if (this.dDatosCompartidosCabecera.concepto === "fraccion" || this.dDatosCompartidosCabecera.concepto === "fraccion_correccion")
      this.booFraccion = true;

    if (this.modelo.doc.cuerpo['cs_id_285'] == 'true' && this.dDatosCompartidosCabecera.concepto == "correccion") {
      let notificaError = this._notifications.showError(MESSAGES.FACTURA_NO_CORREGIBLE);
      notificaError.afterClosed().subscribe(result => this._location.back());
    }
    if (this.dDatosCompartidosCabecera.concepto == "correccion") {
      this.booCorreccion = true;
    }

    //disable 980 pago total
    if (this.firmaRequerida) {
      this.casillasDinamicas.cs_id_980.disabled = true;
      this.modelo.doc.pie.cs_id_980 = "0";
    } else this.casillasDinamicas.cs_id_980.disabled = false;

    this.temporal41 = this.modelo.doc.cuerpo.cs_id_41;
    this.temporal53 = this.modelo.doc.cuerpo.cs_id_53;
    this.temporal69 = this.modelo.doc.cuerpo.cs_id_69;
    this.temporal86 = this.modelo.doc.cuerpo.cs_id_86;

    if (!this.modelo.doc.cuerpo['cs_id_284'])
      this.modelo.doc.cuerpo.cs_id_284 = "1";
    if (!this.modelo.doc.cuerpo['cs_id_140']) {
      this.modelo.doc.cuerpo.cs_id_140 = "0";
      // this.modelo.doc.cuerpo.cs_id_303 = "0";
    }

    this.modelo.doc.cuerpo.cs_id_27 =
      this.dDatosCompartidosCabecera.concepto === "fraccion" ||
        this.dDatosCompartidosCabecera.concepto === "fraccion_correccion" ? "1" : "0";

    this.validateStateForm(true);
    this.calcularTarifasAB();
    //Mostrar datos del formulario
    this._messagesObs.sendMessages('info-form', this.dDatosCompartidosCabecera);
    this._messagesObs.sendMessages('tiene-firma', this.firmaRequerida);
  }


  
  protected onInitCuestionario(respuestas: any) {      
   
  }

  protected onChangeModelo(attrModelo: any) { 
 //   this.siModeloCambio=true;
  }

  protected eventFormulario(evento: string) {
    if (evento === 'atributos_cargados') {
      this.validateStateForm();

      if (!this.isFirstTime) return;

      if (this.atributosDocumento.docAtributos.esPresentado) {
        //this.dNotificacionServicio.mostrarDialogoInformacion(MESSAGES.PRESENTADO);
        //this.showPresentado();
        this.indexSelectedTab = 4;
        return;
      }

      if (this.firmaRequerida && this.atributosDocumento.docAtributos.enProcesoFirmas) {
        this.indexSelectedTab = 2;
        //this._messagesObs.sendMessages('index-selected', this.indexSelectedTab);
        return;
      }

      if (
        this.firmaRequerida &&
        this.atributosDocumento.docAtributos.enProcesoFirmas &&
        !this.atributosDocumento.docAtributos.esPresentado
      ) {
        this.indexSelectedTab = 4;
        return;
      }
      this.isFirstTime = false;
    }

    if (evento === 'definitivo_generado') {
      this.imprimirFormulario();
      this.liquidarPagarFormulario();
    }

    if (evento === 'documento_firmado') {
      this.habilitarSiguienteEnFirma = true;
      this.documentoFirmado = true;
    }

    if (evento === 'documento_no_firmado')
      this.habilitarSiguienteEnFirma = false;

    if (evento === 'habilitar_form') {
      if (this.validarRespuestaCambioTab) {
        this.validarRespuestaCambioTab = false;
        const form = this.el.nativeElement.querySelector('form[id="frmGenerico"]');
        const rbs = form.querySelectorAll('input[type="radio"]');
        for (let i in rbs) {
          if (rbs[i].type === 'radio')
            rbs[i].disabled = false;
        }
        if (this.indexSelectedTab > 0) this.indexSelectedTab--;
      }
    }

    if (evento === 'borrador_guardado' || evento === 'borrador_actualizado')
      this.procesarSinNotificaciones = true;

    if (evento === "formulario_presentado") {
      const cas141 = this.modelo.doc.cuerpo.cs_id_141;
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas141, "0")) {
        this.dNotificacionServicio.mostrarDialogoInformacion("Señor contribuyente, recuerde que debe generar un recibo de pgo concepto 4-Renta para pagar el impuesto declarado y debe generar otro recibo con el concepto 45 Aporte Voluntario para cancelar este aporte.");
      }
    }
    /* Se valida la respuesta de la casilla 994 al actualizar el formulario  */
    if (!this.modelo.doc.pie.hasOwnProperty('cs_id_994') || this.modelo.doc.pie['cs_id_994'] == "false") {
      this.modelo.doc.pie['cs_id_994'] = false;
    }
  }

  protected onUploadFiles(docs: DArchivoBlob[]) { }

  private listenCoreMessagesObs() {
    this._coreMessagesObs.getMessages().subscribe(res => {
      console.log(res);
    });
  }

  //Helpers
  redirectIngreso(): void {
    window.location.href = window.location.origin + '/' + environment.urlIngreso + '/#/ingreso';
  }

  showHelp(id: string, withLink: boolean = false): void {
    const nodesLabel = document.querySelectorAll(`[for="${id}"]`);
    if (!nodesLabel || !nodesLabel.length) return;

    let title = '';

    if (withLink) {
      const textNode = nodesLabel[0].innerHTML;
      const textLink = textNode.match(/<a[^\b>]+>(.+)[\<]\/a>/)[1];
      title = nodesLabel[0].innerHTML.replace(/<a[^\b>]+>(.+)[\<]\/a>/g, textLink);
      title = ' ' + title.replace(/[\t\n]|(&nbsp;)|(<mat-icon).+/gm, '');
    } else
      title = nodesLabel[0].innerHTML.replace(/[\t\n]|(&nbsp;)|(<mat-icon).+/gm, '');

    const help = this.dataHelps.find((item) => item.casilla === id);
    const textFixed = help ? help.texto.replace(/(<b>).+(<\/b>)/m, '') : '';
    this._messagesObs.sendMessages('help', { title: title, text: textFixed });
  }

  private getAnio(): number {
    const anioDeclaracion = (this.modelo.doc.cuerpo.cs_id_27 &&
      (this.modelo.doc.cuerpo.cs_id_27 == "1" || this.modelo.doc.cuerpo.cs_id_27 == "true")) ?
      Number(this.anioDeclaracion) + 1 : this.anioDeclaracion;
    return Number(anioDeclaracion);
  }

  private calcularTarifasAB() {
    const anio2020 = this.modelo.doc.cab.cs_id_1 == "2020";
    const anio2021 = this.modelo.doc.cab.cs_id_1 == "2021";
    const anio2022 = this.modelo.doc.cab.cs_id_1 == "2022";
    const anio2023 = this.modelo.doc.cab.cs_id_1 == "2023";
    const anio2024 = this.modelo.doc.cab.cs_id_1 == "2024";
    const fraccion = this.modelo.doc.cuerpo.cs_id_27 && (this.modelo.doc.cuerpo.cs_id_27 == "1" || this.modelo.doc.cuerpo.cs_id_27 == "true")
    if (anio2020 && !fraccion) {
      this.tarifaA = "0.32";
      this.tarifaB = "0.68";
    } else if (anio2020 && fraccion) {
      this.tarifaA = "0.31";
      this.tarifaB = "0.69";
    } else if (anio2021 && !fraccion) {
      this.tarifaA = "0.31";
      this.tarifaB = "0.69";
    } else if (anio2021 && fraccion) {
      this.tarifaA = "0.35";
      this.tarifaB = "0.65";
    } else if (anio2022 && !fraccion) {
      this.tarifaA = "0.35";
      this.tarifaB = "0.65";
    } else if (anio2022 && fraccion) {
      this.tarifaA = "0.35";
    } else if (anio2023 && !fraccion) {
      this.tarifaA = "0.35";
      this.tarifaB = "0.65";
    } else if (anio2023 && fraccion) {
      this.tarifaA = "0.35";
    } else if (anio2024 && !fraccion) {
      this.tarifaA = "0.35";
      this.tarifaB = "0.65";
    } else if (anio2024 && fraccion) {
      this.tarifaA = "0.35";
    }
    else if(this.getAnio()>=2023 && !fraccion) {
      this.tarifaA = "0.35";
      this.tarifaB = "0.65";
    } else if (this.getAnio()>=2023 && fraccion) {
      this.tarifaA = "0.35";
    }
    
  }

  private convertirPesosUvt(valorPesos) {
    valorPesos = this.dutilidades.deshacerFormatoMoneda(valorPesos);
    let valorOperacion = new BigNumber210(valorPesos);
    valorOperacion = valorOperacion.div(this.UVT);
    valorOperacion = valorOperacion.toFormat();
    const punto = valorOperacion.indexOf(".") + 1;
    if ((punto > 0) && (valorOperacion.length - punto) > 2)
      valorOperacion = valorOperacion.slice(0, -1);
    return String(valorOperacion);
  }

  private aplicarTablaArt241ET(baseGravable, rangos) {
    let desde: boolean = false;
    let hasta: boolean = false;

    for (let i = 0; i < rangos.length; i++) {
      desde = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, baseGravable, rangos[i].desde);
      if ((i + 1) < rangos.length) {
        hasta = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, baseGravable, rangos[i + 1].desde);
      } else {
        hasta = true;
      }
      if (desde && hasta) {
        const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, baseGravable, rangos[i].desde);
        let resultadoMultiplicacion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoResta, rangos[i].tarifa);
        const punto = resultadoMultiplicacion.indexOf(".");
        if (punto != -1) {
          resultadoMultiplicacion = resultadoMultiplicacion.substring(0, punto + 3);
        }
        const resultadoSuma2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultadoMultiplicacion, rangos[i].impuesto);
        const resultadoOperacion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoSuma2, this.UVT);
        return resultadoOperacion;
      }
    }
    return "0";
  }

  private aplicarTablaCasilla121(baseGravable, rangos) {
    let desde: boolean = false;
    let hasta: boolean = false;

    for (let i = 0; i < rangos.length; i++) {
      desde = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, baseGravable, rangos[i].desde);
      if ((i + 1) < rangos.length) {
        hasta = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, baseGravable, rangos[i + 1].desde);
      } else hasta = true;

      if (desde && hasta) {
        const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, baseGravable, rangos[i].desde);
        let resultadoMultiplicacion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoResta, rangos[i].tarifa);
        const punto = resultadoMultiplicacion.indexOf(".");
        if (punto != -1) {
          resultadoMultiplicacion = resultadoMultiplicacion.substring(0, punto + 3);
        }
        const resultadoSuma2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultadoMultiplicacion, rangos[i].impuesto);
        const resultadoOperacion = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoSuma2, this.UVT);
        return resultadoOperacion;
      }
    }

    return "0";
  }
  //Fin Helpers

  //Funciones controladoras de componentes de tabs y stepper del formulario  
  private listenMessagesObs() {
    this._messagesObs.getMessages().subscribe(res => {
      if (res.operation === 'open-decla-sug')
        this.showSecondModalHelpDeclaracionSugerida(true);
      if (res.operation === 'save-form') {
        this.procesarSinNotificaciones = false;
        this.validarPreguntas();
      }
      if (res.operation === 'pdf-form') {
        this.procesarSinNotificaciones = false;
        this.descargarFormulario(true);
      }
    });
  }

  changeTab(add: boolean = true): void {
    if (add && this.indexSelectedTab === 0) {
      //Operaciones
      this.getDataForm();
      //this.dividendosOtros(14);
    }

    if (this.firmaRequerida) this.flowTabsConFirma(add);
    else this.flowTabsSinFirma(add);
  }

  private flowTabsConFirma(add: boolean = true) {
    if (!add && !this.atributosDocumento.docAtributos.esEditable) {
      this.dialog.open(GeneralDialogComponent, {
        disableClose: true,
        data: DialogsConfig.dialogoConfigDesautorizarFirma
      }).afterClosed().subscribe(res => {
        if (!res) return;
        this.validarRespuestaCambioTab = true;
        this.validarCambioFirma();
      });
      return;
    }

    //Mostrar firmar
    if (add && this.indexSelectedTab === 1 && !this.mostrarFirmaBtn) {
      this._notifications.showInfo('Para firmar su declaración, es importante que el documento se encuentre en estado "Borrador".');
      return;
    }

    //Mostrar presentar
    if (add && this.indexSelectedTab === 2 && !this.mostrarPresentarBtn) {
      this._notifications.showInfo("Primero firme el documento para presentarlo.");
      return;
    }

    //Mostrar pagar
    if (add && this.indexSelectedTab === 3 && !this.mostrarPagarBtn) {
      this._notifications.showInfo('Para realizar el pago de su declaración, es importante que el documento se encuentre en estado "Presentado".');
      return;
    }

    if (
      this.atributosDocumento.docAtributos.esPresentado &&
      (
        !this.liquidacionRecigoPago ||
        !this.liquidacionRecigoPago.ideDocumento
      )
    ) {
      this.liquidarPagarFormulario();
      return;
    }

    //Logica normal del componente de tabs
    if (add) {
     // if (this.indexSelectedTab == 0 && !this.atributosDocumento.docAtributos.esPresentado)
      //  this.validateGetSugerida();

      if (this.indexSelectedTab == 1)
        this.validarPreguntas();

      this.indexSelectedTab++;
    } else this.indexSelectedTab--;
    this._messagesObs.sendMessages('index-tab-stepper', {
      tab: this.indexSelectedTab,
      stepper: this.indexStepper
    });
  }

  private flowTabsSinFirma(add: boolean = true) {
    //Mostrar firmar
    if (this.indexSelectedTab === 1) {
      this.dialog.open(GeneralDialogComponent, {
        disableClose: true,
        data: DialogsConfig.dialogoConfigSinFirma
      }).afterClosed().subscribe(res => {
        if (!res) return;
        window.location.href = window.location.origin + '/WebDashboard/DefDashboard.faces';
      });
    }

    if (
      this.atributosDocumento.docAtributos.esDefinitivo &&
      (
        !this.liquidacionRecigoPago ||
        !this.liquidacionRecigoPago.ideDocumento
      )
    ) {
      this.liquidarPagarFormulario();
      return;
    }

    //Logica normal del componente de tabs
    if (add) {
     // if (this.indexSelectedTab == 0 && !this.atributosDocumento.docAtributos.esDefinitivo)
      //  this.validateGetSugerida();

      if (this.indexSelectedTab == 1)
        this.validarPreguntas();

      this.indexSelectedTab++;
    } else this.indexSelectedTab--;
    this._messagesObs.sendMessages('index-tab-stepper', {
      tab: this.indexSelectedTab,
      stepper: this.indexStepper
    });
  }

  private validateGetSugerida(): void {
    if ((
      this.anioDeclaracion >= 2023 &&
      this.dDatosCompartidosCabecera.concepto === 'inicial'
      && ((
        this.modelo.doc.cab.cs_id_4 === 'null' ||
        this.modelo.doc.cab.cs_id_4 === null)
      )) || this.modelo.doc.cuerpo.cs_id_337 === '1')
    {
      if (this.modelo.doc.cab.id === -1 || this.modelo.doc.cuerpo.cs_id_336==='0' ) this.obtenerSugeridaNube();
      
    }
    else this.obtenerDeclaracionSugerida();
  }

  changeStepper(index: number): void {
    this.stepsList.forEach((item, i) => {
      item.active = i == index;
      item.completed = i > index || i == index ? false : true;
    });
    this.indexStepper = index;
    this._messagesObs.sendMessages('index-tab-stepper', {
      tab: this.indexSelectedTab,
      stepper: this.indexStepper
    });

    if (this.stepsToSaveForm.indexOf(this.indexStepper) > -1)
    {
     // if(this.siModeloCambio)
     // {
        this.validarPreguntas();
     // }
    }

    if(this.indexStepper !==0)
      this.validarGenero();
    //////calcula la cedula general con el steper 7
      if(this.indexStepper ===8)
        this.operacionCs91();
      if(this.indexStepper ===13 )
        this.recalcularFormulario(false, false, '', false);
      if(this.indexStepper===14)
        this.recalcularFormulario(false, false, '',false, true); 
    //Set top scroll on contenedor-formulario
    this._messagesObs.sendMessages('scroll-to-top', '');
  }

  validateQuestions(step: number) {
    switch (step) {
      case 1:
        if (this.tiempoPermanencia && this.tiempoPermanencia == '1') this.showEsResidente(true);
        break;
      case 2:
        if (this.completoPeriodoPermanencia && this.completoPeriodoPermanencia == '1') this.showEsResidente(true);
        break;
      case 3:
        if (this.tieneNacionalidadColombiana && this.tieneNacionalidadColombiana == '0') this.showEsResidente(false);
        break;
      case 4:
        if (this.servicioEstadoEnExterior && this.servicioEstadoEnExterior == '1') this.showEsResidente(true);
        break;
      case 5:
        if (this.ingresosJurisdiccionDomicilio === '1' || this.activosJurisdiccionExterior === '1')
          this.showEsResidente(false);
        else {
          if (
            (this.ingresosJurisdiccionDomicilio && this.ingresosJurisdiccionDomicilio === '0') &&
            (this.activosJurisdiccionExterior && this.activosJurisdiccionExterior === '0') &&
            (this.esFamiliaResidenteFiscal && this.esFamiliaResidenteFiscal === '1') ||
            (this.ingresosFuenteNacional && this.ingresosFuenteNacional === '1') ||
            (this.bienesAdministradosColombia && this.bienesAdministradosColombia === '1') ||
            (this.activosPoseidosColombia && this.activosPoseidosColombia === '1') ||
            (this.esResidenteParaisoFiscal && this.esResidenteParaisoFiscal === '1') ||
            (this.noPuedeAcreditarResidenteExterior && this.noPuedeAcreditarResidenteExterior === '0')
          ) this.showEsResidente(true);

          if (
            (this.ingresosJurisdiccionDomicilio && this.ingresosJurisdiccionDomicilio === '0') &&
            (this.activosJurisdiccionExterior && this.activosJurisdiccionExterior === '0') &&
            (this.esFamiliaResidenteFiscal && this.esFamiliaResidenteFiscal === '0') &&
            (this.ingresosFuenteNacional && this.ingresosFuenteNacional === '0') &&
            (this.bienesAdministradosColombia && this.bienesAdministradosColombia === '0') &&
            (this.activosPoseidosColombia && this.activosPoseidosColombia === '0') &&
            (this.esResidenteParaisoFiscal && this.esResidenteParaisoFiscal === '0') &&
            (this.noPuedeAcreditarResidenteExterior && this.noPuedeAcreditarResidenteExterior === '1')
          ) this.showEsResidente(false);
        }
        break;
    }
  }

  private showEsResidente(value: boolean) {
    this.dialog.open(GeneralDialogComponent, {
      disableClose: true,
      data: value ? DialogsConfig.dialogoConfigEsResidente : DialogsConfig.dialogoConfigNoEsResidente
    }).afterClosed().subscribe(res => {
      if (res === '') return;
      if (!value && res) window.location.href = this.ruta110;
      if (value && res) this.changeTab(true);
    });
  }

  private showPresentado() {
    this.dialog.open(GeneralDialogComponent, {
      disableClose: true,
      data: DialogsConfig.dialogoPresentado
    });
  }

  private validateStateForm(changeSection: boolean = false): void {
    if (!this.firmaRequerida) {
      if (this.atributosDocumento.docAtributos.esDefinitivo) {
        this.dDatosCompartidosCabecera.estado = 'Definitivo';
        this._messagesObs.sendMessages('info-form', this.dDatosCompartidosCabecera);
      }
    }

  }
  //Fin Funciones controladoras de componentes de tabs y stepper del formulario

  //Modales de declaración sugerida
  private showFirstModalHelpDeclaracionSugerida() {
    
    const dialog0: MatDialogRef<GeneralDialogComponent> =this.dialog.open(GeneralDialogComponent, {
      disableClose: true,
      data: DialogsConfig.dialogoConfigNoAlertaFactura,
     });
    
    dialog0.afterOpen().subscribe
         (res => {
          dialog0.componentInstance.annioGravable=this.anioDeclaracion;
          dialog0.componentInstance.subtitle=dialog0.componentInstance.data.subtitle+this.anioDeclaracion;
        });
    
    dialog0.afterClosed().subscribe(res => {
      if (!res) return;
      this.showSecondModalHelpDeclaracionSugerida();
    });
  }


  private showSecondModalHelpDeclaracionSugerida(readOnly: boolean = false) {
    this.dialog.open(SugeridaComponent, {
      disableClose: true,
      data: {
        readOnly: readOnly,
        formData: this.declaracionSugerida
      }
    }).afterClosed().subscribe(res => {
      if (!res) {
        this.declaracionSugerida.ideAceptacion = 'N';
        return;
      }
      //Set values declaración sugerida
      this.declaracionSugerida.ideAceptacion = 'S';
      this.setValuesDeclaracionSugerida();
      //this.recalcularFormulario();

    });
  }
  //End Modales de declaración sugerida

  //Obtener declaración sugerida Se debe habilitar nuevamente para actualizar información cuando el contribuyente cierra sesion y guarda posterior 03-06-2025
  private obtenerDeclaracionSugerida() {
      let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
      this.dServicioRESTAPI.obtenerDeclaracionSugerida(this.modelo.doc.cab.cs_id_5, this.anioDeclaracion).subscribe(
        (res: any) => {
          if (!res || !res.length) return;
          this._messagesObs.sendMessages('show-declasug', true);
  
          let alertaFactura = true;
          this.declaracionSugerida = res.find((item: DDeclaracionSugerida) =>
            String(item.ideTipoRegistro) === TIPO_REG_DECLARACION_SUG_FACTURA_RENTA);
  
          if (!this.declaracionSugerida) {
            this.declaracionSugerida = res.find((item: DDeclaracionSugerida) =>
              String(item.ideTipoRegistro) === TIPO_REG_DECLARACION_SUG);
            alertaFactura = false;
          }
  
         // this.showFirstModalHelpDeclaracionSugerida();
          precargaProceso.close();
        }, error => {
          precargaProceso.close();
        }
      );
    }
  
  //Funciones inicializadoras de datos parametricos
  //Valor dominio 109
  private obtenerValorDominio109(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_109).subscribe(
      data => this.setObjectFromResponse(0, data),
      error => console.log(error)
    )
  }

  //Valor dominio 1630
  private obtenerValorDominio1630(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1630).subscribe(
      data => this.setObjectFromResponse(1, data),
      error => console.log(error)
    )
  }

  //Valor dominio 1644
  private obtenerValorDominio1644(): void {
    this.dBasicosParametricasServicios.obtenerValoresDominio(POLITICA_1644, null, null, null, POLITICA_1644_ORDER_FIELD, POLITICA_1644_ORDER_TYPE).subscribe(
      data => this.setObjectFromResponse(2, data),
      error => console.log(error)
    )
  }

  //UVT 
  private obtenerValorPeriodico110(): void {
    this.dBasicosParametricasServicios.obtenerValorPeriodico(VAL_PERIODICO_110, this.getAnio()).subscribe(
      data => this.setObjectFromResponse(3, data),
      error => console.log(error)
    )
  }
  //Consultar NIT para Devoluciones
  private consultarNIT(): void {
    this.dServicioRESTAPI.consultarNit(this.modelo.doc.cab.cs_id_5).subscribe(
      data => this.setObjectFromResponse(7, data),
      error => console.log(error)
    )
  }
  //Actividades vigentes  
  private obtenerActividadesVigentes(): void {
    this.dServicioRESTAPI.consultarActividadesVigentes(String(this.getAnio())).subscribe(
      data => this.setObjectFromResponse(4, data),
      error => console.log(error)
    )
  }

  //Actividades economicas
  private obtenerActividadesEconomicasContribuyente(): void {
    this.dRutServicios.consultarActividadesEconomicasContribuyente(this.modelo.doc.cab.cs_id_5).subscribe(
      data => this.setObjectFromResponse(5, data),
      error => console.log(error)
    )
  }

  //Pago primera cuota
  private buscarPagosPrimeraCuota(): void {
    this.dServicioRESTAPI.pagosPrimeraCuota(this.modelo.doc.cab.cs_id_5, this.modelo.doc.cab.cs_id_1).subscribe(
      data => this.setObjectFromResponse(6, data),
      error => console.log(error)
    )
  }

  ///Consultar Politica devoluciones
  private obtenerPoliticaDevoluciones(): void {
    this.dBasicosParametricasServicios.obtenerPolitica(POLITICA_318,HABILITA_DEVOLUCION).subscribe( // obtenerValorPeriodico(VAL_PERIODICO_110, this.getAnio()).subscribe(
      data => this.setObjectFromResponse(8, data),
      error => console.log(error)
    )
  }

  private getDataForm() {
    this.obtenerValorDominio109();
    this.obtenerValorDominio1630();
    this.obtenerValorDominio1644();
    this.obtenerValorPeriodico110();
    this.obtenerActividadesVigentes();
    this.obtenerActividadesEconomicasContribuyente();
    this.consultarNIT();
    this.obtenerPoliticaDevoluciones();

    if (this.dDatosCompartidosCabecera.concepto === "inicial" && this.tipoContribuyente.granContribuyente)
      this.buscarPagosPrimeraCuota();


  }
  private filtrarParentesco():void{
    
    if(this.anioDeclaracion>=2025){
      this.tiposParentesco=this.tiposParentesco.filter((vd: DValorDominio)=>vd.fechaDesde>=20250101);
      this.tiposParentesco.sort((a:DValorDominio,b:DValorDominio)=>Number(a.valor)-Number(b.valor)); //Se ordenan los items una vez fintrados(Porque quedan desordenados al ser el valor un string ->  6-11)
    }else{
      this.tiposParentesco=this.tiposParentesco.filter((vd: DValorDominio)=>vd.fechaDesde<20250101);
    }
  }

  private setObjectFromResponse(id: number, data: any): void {
    switch (id) {
      case 0:
        this.tiposDocumento = <Array<DValorDominio>>data;
        this.logicaFiltroDocumentos();
        break;
      case 1:
        this.tiposParentesco = <Array<DValorDominio>>data;
        this.filtrarParentesco();
        break;
      case 2:
        this.listaGenero = <Array<DValorDominio>>data;
        break;
      case 3:
        this.logicaUVT(<DValorPeriodico>data);
        break;
      case 4:
        this.listaActividadesEconomicasVigentes = data;
        break;
      case 5:
        if(data.length > 0)
          this.logicaActividadesEconomicas(<DActividadesEconomicas>data);
        break;
      case 6:
        this.tienePrimeraCuota = <DObjetoPagoPrimeraCuota>data;
        this.logicaPrimeraCuota();
        break;
      case 7:
        this.personaRUTJSON=<DDilPersonaRutJSON>data;
        ///////////Habilitar para demos
       //this.validacionCandidato();
       // this.obtenerSugeridaNube();
        this.validateGetSugerida();
        break;
      case 8:
        this.habilitaDevoluciones = data.parametros[0].valor.toString()==='true'?true:false;
        break;
        
   }
  }

  //Funciones negocio
  private logicaFiltroDocumentos() {
    this.tiposDocumentofiltrado = new Array<DValorDominio>();
    this.tiposDocumentofiltrado = this.tiposDocumento.filter((item) => DOCS_FILTER.includes(item.valor))
      .sort((a, b) => a.valor > b.valor ? 1 : a.valor < b.valor ? -1 : 0);
  }

  private logicaPrimeraCuota() {
    let idDocumentoDeclaracion = this.tienePrimeraCuota.ideDocumentoPago;
    if (this.modelo.doc.cab.cs_id_4 == null) {
      this.modelo.doc.cab.cs_id_4 = idDocumentoDeclaracion;
      this.dDatosCompartidosCabecera.numFormulario = idDocumentoDeclaracion;
    }
  }

  private logicaUVT(model: DValorPeriodico) {
    this.UVT = String(model.valor);
    //esta validacion se incluyo por los cambios en las formulas de las casilla 272 y 270, dado que habia inconsistencias en los valores de los documentos guardados antes del cambio en las declaraciones iniciales
    if ((
      this.dDatosCompartidosCabecera.concepto === "correccion" ||
      this.dDatosCompartidosCabecera.concepto === "fraccion_correccion") &&
      !this.modelo.doc.cab.cs_id_4
    ) this.operacionCs270();
  }

  private logicaActividadesEconomicas(list: DActividadesEconomicas) {
    const titleMessage = 'Tenga en cuenta';
    const textButton = 'Entendido';

    if (!list || !list.hasOwnProperty('0')) {
      this._notifications.showInfo(MESSAGE_ACTIVIDADES_ECONOMICAS_EMPTY, titleMessage, null, textButton);
      return;
    }

    if (this.listaActividadesEconomicasVigentes) {
      const actividadEconomica = this.listaActividadesEconomicasVigentes.find((act: any) => list[0].id == act.codigo);
      if (actividadEconomica) {
        if ((!this.modelo.doc.cab.cs_id_4 || this.modelo.doc.cab.cs_id_4 == ""))
          this.modelo.doc.cuerpo.cs_id_24 = actividadEconomica.codigo;
      } else {
        if ((!this.modelo.doc.cuerpo.cs_id_24))
          this._notifications.showInfo(MESSAGE_ACTIVIDADES_ECONOMICAS_EMPTY, titleMessage, null, textButton);
      }
    } else this._notifications.showInfo(MESSAGE_ACTIVIDADES_ECONOMICAS_EMPTY, titleMessage, null, textButton);
  }

  private setValuesDeclaracionSugerida() {
    //Cargar valores en el borrador        
    this.modelo.doc.cuerpo.cs_id_29 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla29, true);
    this.modelo.doc.cuerpo.cs_id_30 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla30, true);
    this.modelo.doc.cuerpo.cs_id_32 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla32, true);
    this.modelo.doc.cuerpo.cs_id_33 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla33, true);
    this.modelo.doc.cuerpo.cs_id_35 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla35, true);
    this.modelo.doc.cuerpo.cs_id_36 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla36, true);
    this.modelo.doc.cuerpo.cs_id_39 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla39, true);
    //  this.modelo.doc.cuerpo.cs_id_41 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla41, true);
    this.modelo.doc.cuerpo.cs_id_43 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla43, true);
    this.modelo.doc.cuerpo.cs_id_44 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla44, true);
    this.modelo.doc.cuerpo.cs_id_47 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla47, true);
    this.modelo.doc.cuerpo.cs_id_48 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla48, true);
    this.modelo.doc.cuerpo.cs_id_51 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla51, true);
    // this.modelo.doc.cuerpo.cs_id_53 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla53, true);
    this.modelo.doc.cuerpo.cs_id_58 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla58, true);
    this.modelo.doc.cuerpo.cs_id_59 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla59, true);
    this.modelo.doc.cuerpo.cs_id_63 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla63, true);
    this.modelo.doc.cuerpo.cs_id_64 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla64, true);
    this.modelo.doc.cuerpo.cs_id_67 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla67, true);
    // this.modelo.doc.cuerpo.cs_id_69 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla69, true);
    this.modelo.doc.cuerpo.cs_id_74 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla74, true);
    this.modelo.doc.cuerpo.cs_id_76 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla76, true);
    this.modelo.doc.cuerpo.cs_id_80 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla80, true);
    this.modelo.doc.cuerpo.cs_id_81 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla81, true);
    this.modelo.doc.cuerpo.cs_id_84 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla84, true);
    // this.modelo.doc.cuerpo.cs_id_86 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla86, true);
    this.modelo.doc.cuerpo.cs_id_98 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla98, true);
    this.modelo.doc.cuerpo.cs_id_99 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla99, true);
    this.modelo.doc.cuerpo.cs_id_100 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla100, true);
    this.modelo.doc.cuerpo.cs_id_102 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla102, true);
    this.modelo.doc.cuerpo.cs_id_104 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla104, true);
    this.modelo.doc.cuerpo.cs_id_105 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla105, true);
    this.modelo.doc.cuerpo.cs_id_107 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla107, true);
    this.modelo.doc.cuerpo.cs_id_108 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla108, true);
    this.modelo.doc.cuerpo.cs_id_110 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla110, true);
    this.modelo.doc.cuerpo.cs_id_112 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla112, true);
    this.modelo.doc.cuerpo.cs_id_123 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla123, true);
    this.modelo.doc.cuerpo.cs_id_124 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla124, true);
    this.modelo.doc.cuerpo.cs_id_125 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla125, true);
    this.modelo.doc.cuerpo.cs_id_131 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla131, true);
    this.modelo.doc.cuerpo.cs_id_132 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla132, true);
    this.modelo.doc.cuerpo.cs_id_133 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla133, true);
    this.modelo.doc.cuerpo.cs_id_134 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla134, true);
    //////////////////////////////////////////////////////////
    ////Agregado Factura Renta 18-08-2022
    this.modelo.doc.cuerpo.cs_id_38 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla38, true);
    this.modelo.doc.cuerpo.cs_id_45 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla45, true);
    this.modelo.doc.cuerpo.cs_id_50 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla50, true);
    this.modelo.doc.cuerpo.cs_id_56 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla56, true);
    this.modelo.doc.cuerpo.cs_id_60 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla60, true);
    this.modelo.doc.cuerpo.cs_id_62 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla62, true);
    this.modelo.doc.cuerpo.cs_id_66 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla66, true);
    this.modelo.doc.cuerpo.cs_id_72 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla72, true);
    this.modelo.doc.cuerpo.cs_id_75 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla75, true);
    this.modelo.doc.cuerpo.cs_id_77 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla77, true);
    this.modelo.doc.cuerpo.cs_id_79 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla79, true);
    this.modelo.doc.cuerpo.cs_id_83 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla83, true);
    this.modelo.doc.cuerpo.cs_id_89 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla89, true);
    this.modelo.doc.cuerpo.cs_id_94 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla94, true);
    this.modelo.doc.cuerpo.cs_id_95 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla95, true);
    this.modelo.doc.cuerpo.cs_id_96 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla96, true);
    this.modelo.doc.cuerpo.cs_id_109 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla109, true);
    this.modelo.doc.cuerpo.cs_id_112 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla112, true);
    this.modelo.doc.cuerpo.cs_id_113 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla113, true);
    this.modelo.doc.cuerpo.cs_id_114 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla114, true);
    this.modelo.doc.cuerpo.cs_id_115 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla115, true);
    this.modelo.doc.cuerpo.cs_id_121 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla121, true);
    this.modelo.doc.cuerpo.cs_id_127 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla127, true);
    this.modelo.doc.cuerpo.cs_id_128 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla128, true);
    this.modelo.doc.cuerpo.cs_id_129 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla129, true);

    //Campos agregados 210 v18
    this.modelo.doc.cuerpo.cs_id_130 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla130, true);
    this.modelo.doc.cuerpo.cs_id_355 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla355, true);
    this.modelo.doc.cuerpo.cs_id_297 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla297, true);
    //05-06-2025
    this.modelo.doc.cuerpo.cs_id_122 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla122, true);
    this.modelo.doc.cuerpo.cs_id_302 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla302, true);

    /////Agrega casillas sugerida nube cas 245 y cas 246 
		///30-06-2026
    this.modelo.doc.cuerpo.cs_id_246 = this.dutilidades.redondearValorMoneda(this.declaracionSugerida.valSugeridoCasilla246, true);

    

	  this.recalcularFormulario(false, false, '', false);
  }

  private recalculoTemporales(): void {
    this.operacionCs271();
    this.operacionCs265();
  }

  validarPregunta(idCasilla: number): void {
    let casillaPregunta = this.modelo.doc.cuerpo['cs_id_' + idCasilla];
    if (idCasilla != 299) {
      if (casillaPregunta == '0') {
        this.modelo.doc.cuerpo['cs_id_' + (idCasilla + 1)] = '0';
        this.recalculoTemporales();
      }
    }
    else {
      if (casillaPregunta == '0') {
        this.modelo.doc.cuerpo['cs_id_297'] = '0';
        this.recalculoTemporales();
      }
    }
  }

  validarGenero(): void {
    if (this.modelo.doc.cuerpo.cs_id_24 == "" || this.modelo.doc.cuerpo.cs_id_24 == null) {
      this._notifications.showInfo(MESSAGES.DILIGENCIA_CAS24);
      this.indexStepper=0;
      this.stepsList.forEach((item, i) => {
        item.active = i == 0;
        item.completed = i > 0 || i == 0 ? false : true;
      });
    }
   const validaGenero: string = this.modelo.doc.cuerpo['cs_id_286'];
      if (!validaGenero) {
        this._notifications.showInfo(MESSAGES.GENERO_OBLIGATORIO);
        this.indexStepper=0;
        this.stepsList.forEach((item, i) => {
          item.active = i == 0;
          item.completed = i > 0 || i == 0 ? false : true;
        });
      }
  }
  validarPreguntas(definitivo?: boolean): void {
    if (this.modelo.doc.cuerpo.cs_id_24 == "" || this.modelo.doc.cuerpo.cs_id_24 == null) {
      this._notifications.showInfo(MESSAGES.DILIGENCIA_CAS24);
      return;
    }
    this.operacionCs298();
    if (this.booTopeindicativo) {
      const validaindicativo= this.modelo.doc.cuerpo['cs_id_140'];
      if (validaindicativo==0) {
          this._notifications.showInfo(MESSAGES.ES_MAYOR);
          return;
      }
    }

      const validaGenero: string = this.modelo.doc.cuerpo['cs_id_286'];
      if (!validaGenero) {
        this._notifications.showInfo(MESSAGES.GENERO_OBLIGATORIO);
        return;
      }
    

    let validacion = true;
    let mensaje = "";
    const preguntas = [];

    preguntas.push({ casilla: "245", valor: this.modelo.doc.cuerpo.cs_id_246, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32 });
    preguntas.push({ casilla: "247", valor: this.modelo.doc.cuerpo.cs_id_248, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32 });
    preguntas.push({ casilla: "249", valor: this.modelo.doc.cuerpo.cs_id_250, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32 });
    preguntas.push({ casilla: "251", valor: this.modelo.doc.cuerpo.cs_id_252, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32 });
    preguntas.push({ casilla: "253", valor: this.modelo.doc.cuerpo.cs_id_254, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32 });
    preguntas.push({ casilla: "282", valor: this.modelo.doc.cuerpo.cs_id_281, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32 });
    preguntas.push({ casilla: "279", valor: this.modelo.doc.cuerpo.cs_id_280, casillaControl: "32", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_32 });
    preguntas.push({ casilla: "255", valor: this.modelo.doc.cuerpo.cs_id_256, casillaControl: "74", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_74 });
    preguntas.push({ casilla: "277", valor: this.modelo.doc.cuerpo.cs_id_278, casillaControl: "74", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_74 });
    preguntas.push({ casilla: "275", valor: this.modelo.doc.cuerpo.cs_id_276, casillaControl: "58", valorCasillaControl: this.modelo.doc.cuerpo.cs_id_58 });

    for (let pregunta of preguntas) {
      if (pregunta.valor == "" || pregunta.valor == "0" || pregunta.valor == null) {
        this.modelo.doc.cuerpo['cs_id_' + pregunta.casilla] = "0";
      } else if (pregunta.casilla != "27" && pregunta.valor == "1" && this.modelo.doc.cuerpo['cs_id_' + (Number(pregunta.casilla) + 1)] == "0") {
        mensaje = "Debo agregar un valor en la casilla " + (Number(pregunta.casilla) + 1) + ". Por favor verifique.";
        validacion = false;
        break;
      } else if (pregunta.valor == "1" && pregunta.valorCasillaControl == "0") {
        mensaje = "no puede contestar sí en la pregunta de la casilla " + pregunta.casilla + " por que, el valor de la casilla " + pregunta.casillaControl + " es 0. Por favor verifique.";
        validacion = false;
        break;
      }
    }

    
    //let precalculo = this.dNotificacionServicio.mostrarDialogoCarga();
    //precalculo.beforeClose().subscribe(result => {
    this.contarDependientes();
    this.modelo.doc.cuerpo.cs_id_138=''+this.cuentadependientes;
    this.recalcularFormulario(definitivo, validacion, mensaje, true,true);
    //});
    //precalculo.close();

    
    
  }

  validarDeclaSugeridaPresentar() {
    if (this.declaracionSugerida) {
      this.asignarValoresRealesDeclaracionSugerida();
      this.declaracionSugerida.ideDocumento = this.modelo.doc.cab.id;
      this.declaracionSugerida.numRepeticion = this.modelo.doc.cab.n_r;
      this.actualizarDeclaracionSugerida(this.declaracionSugerida);
    }
    this.modelo.doc.cuerpo.cs_id_337='0';
    this.modelo.doc.cuerpo.cs_id_336='16500002'; //Experto
    this.presentarFormulario();
    
    let booltiensaldoafavor=false; 
    const cas137 =this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_137);
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas137, "0"))
    {
      booltiensaldoafavor = true;
    }
    if(this.habilitaDevoluciones && booltiensaldoafavor)
      {
        this.validacionCandidato();
      }
    else
    {
      this.showPresentado();
      //this.dNotificacionServicio.mostrarDialogoInformacion(MESSAGES.PRESENTADO);
    }
    
   
  }

  validarDeclaSugeridaGuardarDefinitivo() {
    if (this.declaracionSugerida) {
      this.asignarValoresRealesDeclaracionSugerida();
      this.declaracionSugerida.ideDocumento = this.modelo.doc.cab.id;
      this.declaracionSugerida.numRepeticion = this.modelo.doc.cab.n_r;
      this.actualizarDeclaracionSugerida(this.declaracionSugerida);
    }
    this.modelo.doc.cuerpo.cs_id_337='0';
    this.modelo.doc.cuerpo.cs_id_336='16500002'; //Experto
    this.guardarFormularioDefinitivo();
   // this.siModeloCambio=false;
  }

  validarDeclaSugeridaGuardar() {
    if (this.declaracionSugerida) {
     // this.limpiaformatoSugeridos();
      this.asignarValoresRealesDeclaracionSugerida();
      this.actualizarDeclaracionSugerida(this.declaracionSugerida);
    }
    this.modelo.doc.cuerpo.cs_id_337='0';
    this.modelo.doc.cuerpo.cs_id_336='16500002'; //Experto
    //Activa las notificaciones y loader del guardado por ser la ultima sección del formulario
    this.procesarSinNotificaciones = this.indexStepper === 14 ? false : true;
    if (this.firmaRequerida && this.atributosDocumento.docAtributos.esPresentado) return;
    if (!this.firmaRequerida && this.atributosDocumento.docAtributos.esDefinitivo) return;
    this.guardarActualizarBorrador();
    //this.siModeloCambio=false;
  }

  private actualizarDeclaracionSugerida(declaracionSugerida: any): void {
  //  let precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
    declaracionSugerida.valSugeridoCasilla32= declaracionSugerida.valSugeridoCasilla355 != null? declaracionSugerida.valSugeridoCasilla355:'0';
    delete declaracionSugerida['status'];
    delete declaracionSugerida['statusText'];
   /* delete declaracionSugerida['valSugeridoCasilla355'];
    delete declaracionSugerida['valSugeridoCasilla297'];
    delete declaracionSugerida['valSugeridoCasilla302'];
    delete declaracionSugerida['valSugeridoCasilla122'];
    delete declaracionSugerida['valSugeridoCasilla130'];*/

    this.dServicioRESTAPI.actualizarDeclaracionSugerida(this.modelo.doc.cab.cs_id_5, declaracionSugerida).subscribe(
      res =>declaracionSugerida, //precargaProceso.close(),
      error =>declaracionSugerida //precargaProceso.close()
    );
  }

  private asignarValoresRealesDeclaracionSugerida() {
    //actualizar valores reales    
    this.declaracionSugerida.valRealCasilla29 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_29);
    this.declaracionSugerida.valRealCasilla30 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_30);
    this.declaracionSugerida.valRealCasilla32 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_32);
    this.declaracionSugerida.valRealCasilla33 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_33);
    this.declaracionSugerida.valRealCasilla35 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_35);
    this.declaracionSugerida.valRealCasilla36 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_36);
    this.declaracionSugerida.valRealCasilla39 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_39);
    //  this.declaracionSugerida.valRealCasilla41 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_41);
    this.declaracionSugerida.valRealCasilla43 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_43);
    this.declaracionSugerida.valRealCasilla44 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_44);
    this.declaracionSugerida.valRealCasilla47 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_47);
    this.declaracionSugerida.valRealCasilla48 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_48);
    this.declaracionSugerida.valRealCasilla51 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_51);
    //  this.declaracionSugerida.valRealCasilla53 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_53);  
    this.declaracionSugerida.valRealCasilla58 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_58);
    this.declaracionSugerida.valRealCasilla59 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_59);
    this.declaracionSugerida.valRealCasilla63 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_63);
    this.declaracionSugerida.valRealCasilla64 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_64);
    this.declaracionSugerida.valRealCasilla67 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_67);
    //  this.declaracionSugerida.valRealCasilla69 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_69);
    this.declaracionSugerida.valRealCasilla74 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_74);
    this.declaracionSugerida.valRealCasilla76 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_76);
    this.declaracionSugerida.valRealCasilla80 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_80);
    this.declaracionSugerida.valRealCasilla81 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_81);
    this.declaracionSugerida.valRealCasilla84 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_84);
    // this.declaracionSugerida.valRealCasilla86 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_86);  
    this.declaracionSugerida.valRealCasilla98 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_98);
    this.declaracionSugerida.valRealCasilla99 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_99);
    this.declaracionSugerida.valRealCasilla100 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_100);
    this.declaracionSugerida.valRealCasilla102 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_102);
    this.declaracionSugerida.valRealCasilla104 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_104);
    this.declaracionSugerida.valRealCasilla105 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_105);
    this.declaracionSugerida.valRealCasilla107 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_107);
    this.declaracionSugerida.valRealCasilla108 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_108);
    this.declaracionSugerida.valRealCasilla110 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_110);
    this.declaracionSugerida.valRealCasilla112 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_112);
    this.declaracionSugerida.valRealCasilla123 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_123);
    this.declaracionSugerida.valRealCasilla124 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_124);
    this.declaracionSugerida.valRealCasilla125 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_125);
    this.declaracionSugerida.valRealCasilla131 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_131);
    this.declaracionSugerida.valRealCasilla132 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_132);
    this.declaracionSugerida.valRealCasilla133 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_133);
    this.declaracionSugerida.valRealCasilla134 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_134);
    /////////////////////////////////////////////////////////////////////////
    ////////Agregado Factura Renta 18-08-2022
    ////////////////////////////////////////////////////////////////////////
    this.declaracionSugerida.valRealCasilla38 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_38);
    this.declaracionSugerida.valRealCasilla45 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_45);
    this.declaracionSugerida.valRealCasilla50 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_50);
    this.declaracionSugerida.valRealCasilla56 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_56);
    this.declaracionSugerida.valRealCasilla60 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_60);
    this.declaracionSugerida.valRealCasilla62 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_62);
    this.declaracionSugerida.valRealCasilla66 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_66);
    this.declaracionSugerida.valRealCasilla72 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_72);
    this.declaracionSugerida.valRealCasilla75 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_75);
    this.declaracionSugerida.valRealCasilla77 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_77);
    this.declaracionSugerida.valRealCasilla79 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_79);
    this.declaracionSugerida.valRealCasilla83 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_83);
    this.declaracionSugerida.valRealCasilla89 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_89);
    this.declaracionSugerida.valRealCasilla94 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_94);
    this.declaracionSugerida.valRealCasilla95 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_95);
    this.declaracionSugerida.valRealCasilla96 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_96);
    this.declaracionSugerida.valRealCasilla109 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_109);
    this.declaracionSugerida.valRealCasilla112 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_112);
    this.declaracionSugerida.valRealCasilla113 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_113);
    this.declaracionSugerida.valRealCasilla114 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_114);
    this.declaracionSugerida.valRealCasilla115 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_115);
    this.declaracionSugerida.valRealCasilla121 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_121);
    this.declaracionSugerida.valRealCasilla127 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_127);
    this.declaracionSugerida.valRealCasilla128 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_128);
    this.declaracionSugerida.valRealCasilla129 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_129);

    //Agregados 2025-06-05 F210 v18
    this.declaracionSugerida.valRealCasilla122 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_122);
    this.declaracionSugerida.valRealCasilla130 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_130);
    this.declaracionSugerida.valRealCasilla297 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_297);
    this.declaracionSugerida.valRealCasilla302 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_302);
    this.declaracionSugerida.valRealCasilla355 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_355);


    //Agregados 2026-07-06
    this.declaracionSugerida.valRealCasilla245 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_245);
    this.declaracionSugerida.valRealCasilla246 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_246);
    



    //const booltipoDeclaracion = this.comparaSugerida();
    /*if (booltipoDeclaracion && this.declaracionSugerida.ideTipoRegistro == '60600003') {
      this.declaracionSugerida.ideTipoDeclaracion = 34031011;
      this.modelo.doc.cuerpo.cs_id_285 = 'true';
    } else {*/
    this.declaracionSugerida.ideTipoDeclaracion = 34022891;
    this.modelo.doc.cuerpo.cs_id_285 = 'false';
    //}

    if (!this.declaracionSugerida.ideAceptacion)
      this.declaracionSugerida.ideAceptacion = 'S';
  }
 /* Deshabilitado 2025-06-05 
 private limpiaformatoSugeridos() {
    //actualizar valores reales    
    this.declaracionSugerida.valSugeridoCasilla29 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_29);
    this.declaracionSugerida.valSugeridoCasilla30 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_30);
    this.declaracionSugerida.valSugeridoCasilla32 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_32);
    this.declaracionSugerida.valSugeridoCasilla33 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_33);
    this.declaracionSugerida.valSugeridoCasilla35 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_35);
    this.declaracionSugerida.valSugeridoCasilla36 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_36);
    this.declaracionSugerida.valSugeridoCasilla39 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_39);
    //  this.declaracionSugerida.valSugeridoCasilla41 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_41);
    this.declaracionSugerida.valSugeridoCasilla43 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_43);
    this.declaracionSugerida.valSugeridoCasilla44 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_44);
    this.declaracionSugerida.valSugeridoCasilla47 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_47);
    this.declaracionSugerida.valSugeridoCasilla48 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_48);
    this.declaracionSugerida.valSugeridoCasilla51 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_51);
    //  this.declaracionSugerida.valSugeridoCasilla53 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_53);  
    this.declaracionSugerida.valSugeridoCasilla58 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_58);
    this.declaracionSugerida.valSugeridoCasilla59 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_59);
    this.declaracionSugerida.valSugeridoCasilla63 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_63);
    this.declaracionSugerida.valSugeridoCasilla64 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_64);
    this.declaracionSugerida.valSugeridoCasilla67 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_67);
    //  this.declaracionSugerida.valSugeridoCasilla69 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_69);
    this.declaracionSugerida.valSugeridoCasilla74 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_74);
    this.declaracionSugerida.valSugeridoCasilla76 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_76);
    this.declaracionSugerida.valSugeridoCasilla80 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_80);
    this.declaracionSugerida.valSugeridoCasilla81 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_81);
    this.declaracionSugerida.valSugeridoCasilla84 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_84);
    // this.declaracionSugerida.valSugeridoCasilla86 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_86);  
    this.declaracionSugerida.valSugeridoCasilla98 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_98);
    this.declaracionSugerida.valSugeridoCasilla99 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_99);
    this.declaracionSugerida.valSugeridoCasilla100 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_100);
    this.declaracionSugerida.valSugeridoCasilla102 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_102);
    this.declaracionSugerida.valSugeridoCasilla104 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_104);
    this.declaracionSugerida.valSugeridoCasilla105 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_105);
    this.declaracionSugerida.valSugeridoCasilla107 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_107);
    this.declaracionSugerida.valSugeridoCasilla108 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_108);
    this.declaracionSugerida.valSugeridoCasilla110 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_110);
    this.declaracionSugerida.valSugeridoCasilla112 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_112);
    this.declaracionSugerida.valSugeridoCasilla123 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_123);
    this.declaracionSugerida.valSugeridoCasilla124 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_124);
    this.declaracionSugerida.valSugeridoCasilla125 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_125);
    this.declaracionSugerida.valSugeridoCasilla131 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_131);
    this.declaracionSugerida.valSugeridoCasilla132 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_132);
    this.declaracionSugerida.valSugeridoCasilla133 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_133);
    this.declaracionSugerida.valSugeridoCasilla134 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_134);
    /////////////////////////////////////////////////////////////////////////
    ////////Agregado Factura Renta 18-08-2022
    ////////////////////////////////////////////////////////////////////////
    this.declaracionSugerida.valSugeridoCasilla38 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_38);
    this.declaracionSugerida.valSugeridoCasilla45 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_45);
    this.declaracionSugerida.valSugeridoCasilla50 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_50);
    this.declaracionSugerida.valSugeridoCasilla56 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_56);
    this.declaracionSugerida.valSugeridoCasilla60 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_60);
    this.declaracionSugerida.valSugeridoCasilla62 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_62);
    this.declaracionSugerida.valSugeridoCasilla66 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_66);
    this.declaracionSugerida.valSugeridoCasilla72 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_72);
    this.declaracionSugerida.valSugeridoCasilla75 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_75);
    this.declaracionSugerida.valSugeridoCasilla77 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_77);
    this.declaracionSugerida.valSugeridoCasilla79 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_79);
    this.declaracionSugerida.valSugeridoCasilla83 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_83);
    this.declaracionSugerida.valSugeridoCasilla89 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_89);
    this.declaracionSugerida.valSugeridoCasilla94 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_94);
    this.declaracionSugerida.valSugeridoCasilla95 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_95);
    this.declaracionSugerida.valSugeridoCasilla96 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_96);
    this.declaracionSugerida.valSugeridoCasilla109 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_109);
    this.declaracionSugerida.valSugeridoCasilla112 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_112);
    this.declaracionSugerida.valSugeridoCasilla113 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_113);
    this.declaracionSugerida.valSugeridoCasilla114 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_114);
    this.declaracionSugerida.valSugeridoCasilla115 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_115);
    this.declaracionSugerida.valSugeridoCasilla121 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_121);
    this.declaracionSugerida.valSugeridoCasilla127 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_127);
    this.declaracionSugerida.valSugeridoCasilla128 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_128);
    this.declaracionSugerida.valSugeridoCasilla129 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_129);

   
  }*/

  

  validarCambioFirma() {
    if (this.cambioFirma && !this.atributosDocumento.docAtributos.enProcesoFirmas)
      this._notifications.showInfo("Hemos detectado que no ha guardado su borrador. Realizar esta acción antes de iniciar su proceso de firma.");
    else this.consultarFirmantes();
  }
 
  private recalcularFormulario(definitivo: boolean, validacion:boolean, mensaje: string, debeEjecutar:boolean,boolCasilla126?:boolean): void {
    let id=126
    const preloader = this.dNotificacionServicio.mostrarDialogoCarga('Cargando');
    const obs = new Observable(observer => {
      try {
        setTimeout(() => {
          
            console.log("ini operaciones");

            this.boolfinal=debeEjecutar;
            if(boolCasilla126)
              this.boolfinal=true;
            this.operacionCs31();
            

            //RENTAS DE TRABAJO
            this.operacionCs32_33();
            //HONORARIOS
            this.operacionCs46();
            //CAPITAL
            this.operacionCs61();
            //RENTA NO LABORAL
            this.operacionCs78();

            //Cedula General
            this.operacionCs91();

            //Cedula de pensiones
            this.operacionCs101();

            //Dividendos y participaciones
            this.operacionCs106();

            //Ganancia ocacional
            this.operacionCs114();
        
            this.boolfinal=false;
          
          
          console.log("fin operaciones");
          if(debeEjecutar)
            this.ejecutarGuardadoPostRecalculo(definitivo,validacion, mensaje);
          observer.next();  
          observer.complete(); 
        }, 2000);         
      } catch (e) {
        observer.error(e);
      }
    });  
    
    obs.subscribe(
      res => {
        preloader.close();
        if (id === 126)
          this._messagesObs.sendMessages('calculado126', true);
        if (id === 129)
          this._messagesObs.sendMessages('calculado129', true);
      },
      error => preloader.close(),
      () => preloader.close()
    );
  }

  operPorcenDividendos(casilla: string) {
    const porcentaje: string = this.modelo.doc.cuerpo[casilla];

    this.dNotificacionServicio.mostrarDialogoConfirmacion(MESSAGES.TARIFA_DIVIDENDOS);
    let booporcentaje: boolean = false;
    for (let tipoPorcen of this.porcDividendos) {
      if (porcentaje == tipoPorcen) {
        booporcentaje = true;
        break;
      } else booporcentaje = false;
    }

    if (!booporcentaje) {
      this.dNotificacionServicio.mostrarDialogoError("El valor " + porcentaje + " Debe coincidir con los valores porcentuales");
      this.modelo.doc.cuerpo[casilla] = 0;
    }
    //this.operacionCs97();
    this.operacionCs108();
    this.operacionCs120();
    this.operacionCs298();
  }

  operacionDividendos(tarifa: string, base: string, impuesto: string) {
    let porcentaje: string = this.modelo.doc.cuerpo[tarifa];
    porcentaje = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, porcentaje, '100');
    let basemultiplica: string = this.modelo.doc.cuerpo[base];
    basemultiplica = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, basemultiplica, porcentaje);
    this.modelo.doc.cuerpo[impuesto] = this.dutilidades.redondearValorMoneda(basemultiplica,true);
    //this.operacionCs108();
    //this.operacionCs120();
    this.operacionCs97();
    this.operacionCs298();
  }

/*dividendosOtros(repeteciones: number) {
    let cuenta300: number = 304;
    this.strDividendosOtros = '<div fxLayout="row">';
    for (let cuenta = 1; cuenta <= repeteciones; cuenta++) {
      this.strDividendosOtros += '<div fxFlex><label for="cs_id_' + cuenta300 + '">' + cuenta300 + '. Tarifa ' + cuenta + ':  </label><input type="text" id="cs_id_' + cuenta300 + '" name="cs_id_' + cuenta300 + '" class="inputs-form number-value" formatoMoneda [redondear]="true" [maxLength]="18" #focusable' + cuenta300 + ' (blur)="operacionCs106()" [(ngModel)]="modelo.doc.cuerpo.cs_id_' + cuenta300 + '" (keyup.enter)="cambioFocoCasillas($event, ';
      cuenta300++;
      this.strDividendosOtros += 'focusable' + cuenta300 + ')" [mostrarAyuda]="modelo.doc.cab.cs_id_1"> </div> <span class="separator-inputs-form"></span> <div fxFlex> <label for="cs_id_' + cuenta300 + '">' + cuenta300 + '. Base ' + cuenta + ':  </label> <input type="text" id="cs_id_' + cuenta300 + '" name="cs_id_' + cuenta300 + '" class="inputs-form number-value" formatoMoneda [redondear]="true" [maxLength]="18" #focusable' + cuenta300 + ' (blur)="operacionCs106()" [(ngModel)]="modelo.doc.cuerpo.cs_id_' + cuenta300 + '" (keyup.enter)="cambioFocoCasillas($event, ';
      cuenta300++;
      this.strDividendosOtros += 'focusable' + cuenta300 + ')" [mostrarAyuda]="modelo.doc.cab.cs_id_1"> </div> <span class="separator-inputs-form"></span> <div fxFlex [mostrarAyuda]="modelo.doc.cab.cs_id_1" [idChild]="cs_id_76"> <label for="' + cuenta300 + '">' + cuenta300 + '. Impuesto dividendo ' + cuenta + ': </label> <input 	type="text" id="cs_id_' + cuenta300 + '" name="cs_id_' + cuenta300 + '" class="inputs-form number-value" disabled #focusable' + cuenta300 + ' [(ngModel)]="modelo.doc.cuerpo.cs_id_' + cuenta300 + '" [mostrarAyuda]="modelo.doc.cab.cs_id_1">';
    }
    this.strDividendosOtros += '</div>';
  }*/

  mensajeAporte()
  {
    this.dNotificacionServicio.mostrarDialogoInformacion(MESSAGES.APORTE_VOLUNTARIO);
    
  }

  descargarFormulario(sinDialog?:boolean): void {
    this.imprimirFormulario();
    if(!sinDialog)
      this._notifications.showInfo("Documento descargado con éxito", null, null, "Entendido");
  }

  liquidarPagarFormulario(): void {
    //Pago COP
    const precarga = this.dNotificacionServicio.mostrarDialogoCarga();
    this.dServicioREST.generarLiquidacionReciboPago(this.modelo.doc.cab.cs_id_4).subscribe(
      res => {
        this.liquidacionRecigoPago = <DLiquidacionRecibo>res.dliquidacionReciboTO;
        if(res.aporteVoluntario && res.aporteVoluntario!=null && res.aporteVoluntario !='')
        {
          this.aporteVoluntario = Number(res.aporteVoluntario);
          if( this.aporteVoluntario<=0)
            this.liquidacionRecigoPago.conceptos.splice(1);
          else
          {
            this.dNotificacionServicio.mostrarDialogoInformacion("Señor(a) usuario(a)", "Usted digito la casilla 141 de aporte Voluntario, por favor genere recibo de pago 490, concepto 45");
            this.liquidacionRecigoPago.aporteVoluntario=this.dutilidades.redondearValorMoneda(""+this.aporteVoluntario, true);
            this.liquidacionRecigoPago.impuestoconVoluntario=JSON.parse(JSON.stringify(this.liquidacionRecigoPago.totalValorMonetario.impuesto));
            this.liquidacionRecigoPago.totalConVoluntario=JSON.parse(JSON.stringify(this.liquidacionRecigoPago.totalValorMonetario.totalPagar));
          }
        }
        else
          this.liquidacionRecigoPago.conceptos.splice(1);
        
        this.indexSelectedTab = this.firmaRequerida ? 4 : 3;
        precarga.close();
      },
      error => {
        precarga.close();
        this._notifications.showError('No fue posible generar el recibo de pago.');
      });
  }

  descargarPDFPago(): void {
    const preloader = this.dNotificacionServicio.mostrarDialogoCarga();
    this._restPago.descargarPDFReciboPago(String(this.reciboPago.ideDocumento))
      .subscribe(
        res => {
          let descarga: DRespuestaSimple = new DRespuestaSimple();
          descarga = res;
          const mediaType = 'application/pdf';
          const blob = new Blob([descarga.blob], { type: mediaType });
          const filename = this.reciboPago.ideDocumento + '.pdf';
          saveAs(blob, filename);
          preloader.close();
        },
        error => {
          this._notifications.showError('Error generando PDF', error.descripcion);
          preloader.close();
        }
      );
  }
  validacionCandidato(){
   
    const config = {
      personaRUT: this.personaRUTJSON,
      modelo: this.modelo.doc,
      contextoEstadoRUT: this.datosContexto.estadoRUT,
      booFraccion: this.booFraccion,
      esExtemporaneo: this.extemporaneidad.esExtemporaneo,
      tipoDocumento: this.datosContexto.tipoDocumento
    };
    let dialogDevoluciones = this.dialog.open(DevolucionesComponent);    
    dialogDevoluciones.componentInstance.data = config;

    dialogDevoluciones.afterClosed().subscribe(res => {
      if (!res) return;
      if (res.includes("http://") || res.includes("https://"))
        window.location.href = res;
     
    });
    

   
  }

  obtenerSugeridaNube() {   
  /*  this._messagesObs.sendMessages('show-declasug', true);

    this.asignaCasillaSugerida(" ");
    this.showFirstModalHelpDeclaracionSugerida(); */
    const preloader = this.dNotificacionServicio.mostrarDialogoCarga();
    this.dContextoUsuario.consultarContextoUsuarioMuisca().subscribe(
      (res: DContextoMuisca) => {
        const contexto = <DContextoMuisca>JSON.parse(sessionStorage.getItem('DIAN-MUISCATK'));
        if (!contexto) {
          preloader.close();
          this.dNotificacionServicio.mostrarDialogoError("Error obteniendo el contexto para la declaraciÃ³n sugerida desde nube");
          return;
        }

        this._restSugeridaNube.initialize(contexto.token.idToken, contexto.token.clientId);                
        this._restSugeridaNube.obtenerSugeridaNube(Number(this.personaRUTJSON.codigoPersonaMas),this.anioDeclaracion,this.dDatosCompartidosCabecera.periodo,this.dDatosCompartidosCabecera.periodicidad).subscribe(//"CC",""+this.personaRUTJSON.nit
          res => {
            preloader.close();
            if (!res) return;
            this.asignaCasillaSugerida(res);
            if(""+this.declaracionSugerida.anioGravable===""+this.anioDeclaracion)
            {
              this._messagesObs.sendMessages('show-declasug', true);
              this.showFirstModalHelpDeclaracionSugerida();
            }
            
          },
          error => 
          {
            //////Deshabilitar solo desarrollo////////////////
            /*this.asignaCasillaSugerida(" ");
            if(""+this.declaracionSugerida.anioGravable===""+this.anioDeclaracion)
              {
                this._messagesObs.sendMessages('show-declasug', true);
                this.showFirstModalHelpDeclaracionSugerida();
              }*/
            /////////////////////////////////////////////////////
            preloader.close();
            //this.dNotificacionServicio.mostrarDialogoInformacion("Error en la consulta del servicio de sugerida en nube");
           
          }
        ); 
      }
    );  
    
  }
  

  //Funciones de operaciones de casillas
  operacionCs31(): void {
    const cas29 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_29, true);
    const cas30 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_30, true);
    const resultadoResta31 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas29, cas30, true);
    const resultadoOperacion31 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta31, "0") ? "0" : resultadoResta31;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion31, true);
    this.modelo.doc.cuerpo.cs_id_31 = String(valorRedondeado);
  }

  operacionCs34(): void {
    const cas32 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_32, true);
    const cas33 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_33, true);
    const resultadoResta34 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas32, cas33, true);
    const resultadoOperacion34 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta34, "0") ? "0" : resultadoResta34;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion34, true);
    this.modelo.doc.cuerpo.cs_id_34 = String(valorRedondeado);
    this.operacionCs37();
  }

  operacionCs37(): void {
    const cas35 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_35, true);
    const cas36 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_36, true);
    const resultadoResta37 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas35, cas36, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoResta37, true);
    this.modelo.doc.cuerpo.cs_id_37 = String(valorRedondeado);
    this.operacionCs40();
  }

  operacionCs40(): void {
    const cas38 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_38, true);
    const cas39 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_39, true);
    const resultadoResta40 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas38, cas39, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoResta40, true);
    this.modelo.doc.cuerpo.cs_id_40 = String(valorRedondeado);
    this.operacionCs270();
    this.operacionCs41();
  }

  operacionCs41(): void {
    const cas37 = this.modelo.doc.cuerpo.cs_id_37;
    const cas40 = this.modelo.doc.cuerpo.cs_id_40;
    const cas34 = this.modelo.doc.cuerpo.cs_id_34;
    const cas273 = this.modelo.doc.cuerpo.cs_id_273;
    const resultadoSuma37y40 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas37, cas40, true);

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, resultadoSuma37y40, "0")) {
      this.modelo.doc.cuerpo.cs_id_41 = "0";
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma37y40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, resultadoSuma37y40, cas34)) {
      this.modelo.doc.cuerpo.cs_id_41 = resultadoSuma37y40;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma37y40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, resultadoSuma37y40, cas34)) {
      this.modelo.doc.cuerpo.cs_id_41 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas34, cas273) ? cas34 : cas273;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, resultadoSuma37y40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, resultadoSuma37y40, cas34)) {
      this.modelo.doc.cuerpo.cs_id_41 = cas273;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, resultadoSuma37y40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, resultadoSuma37y40, cas34)) {
      this.modelo.doc.cuerpo.cs_id_41 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas34, cas273) ? cas34 : cas273;
    }

    this.operacionCs42();
    //this.operacionCs265();
    //this.operacionCs273();
  }

  operacionCs42(): void {
    const cas34 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_34, true);
    const cas41 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_41, true);
    const resultadoResta42 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas34, cas41, true);
    const resultadoOperacion42 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta42, "0") ? "0" : resultadoResta42;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion42, true);
    this.modelo.doc.cuerpo.cs_id_42 = String(valorRedondeado);
    //this.operacionCs91();
  }

  operacionCs46(): void {
    const camposResta = ['cs_id_44', 'cs_id_45'];
    const cas43 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_43, true);
    const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas43, resultadoCamposResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_46 = valorRedondeado;
    if(this.declaracionSugerida && this.declaracionSugerida.valSugeridoCasilla51 !='0')
    {
      const cas50 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_50, true);
      const cas51 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_51, true);
      const resultadoResta52 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas50, cas51, true);
      const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoResta52, true);
      this.modelo.doc.cuerpo.cs_id_52 = String(valorRedondeado);
    }
    if(this.declaracionSugerida && this.declaracionSugerida.valSugeridoCasilla47 !='0')
    {
      const cas47 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_47, true);
      const cas48 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_48, true);
      const resultadoResta49 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas47, cas48, true);
      const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoResta49, true);
      this.modelo.doc.cuerpo.cs_id_49 = String(valorRedondeado);
    }
    this.operacionCs53();
  }

  operacionCs49(): void {
    const cas47 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_47, true);
    const cas48 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_48, true);
    const resultadoResta49 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas47, cas48, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoResta49, true);
    this.modelo.doc.cuerpo.cs_id_49 = String(valorRedondeado);
    this.operacionCs53();
  }

  operacionCs52(): void {
    const cas50 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_50, true);
    const cas51 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_51, true);
    const resultadoResta52 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas50, cas51, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoResta52, true);
    this.modelo.doc.cuerpo.cs_id_52 = String(valorRedondeado);
    this.operacionCs53();
    this.operacionCs266();
  }

  operacionCs53(): void {
    const cas49 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_49);
    const cas52 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_52);
    const suma49_52 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas49, cas52, true);
    const cas46 = this.modelo.doc.cuerpo.cs_id_46;
    const cas265 = this.modelo.doc.cuerpo.cs_id_265;

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, suma49_52, "0")) {
      this.modelo.doc.cuerpo.cs_id_53 = "0";
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma49_52, cas46)) {
      this.modelo.doc.cuerpo.cs_id_53 = suma49_52;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma49_52, cas46)) {
      this.modelo.doc.cuerpo.cs_id_53 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas46, cas265) ? cas46 : cas265;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma49_52, cas46)) {
      this.modelo.doc.cuerpo.cs_id_53 = cas265;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma49_52, cas46)) {
      this.modelo.doc.cuerpo.cs_id_53 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas46, cas265) ? cas46 : cas265;
    }

    this.operacionCs54();
    this.operacionCs265();
  }

  operacionCs54(): void {
    const cas43 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_43, true);
    const camposResta = ['cs_id_44', 'cs_id_45', 'cs_id_53'];
    const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas43, resultadoCamposResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_54 = valorRedondeado;
    this.operacionCs55();
  }

  operacionCs55(): void {
    const cas43 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_43, true);
    const camposSuma = ['cs_id_44', 'cs_id_45'];
    const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposSuma, cas43, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_55 = valorRedondeado;
    this.operacionCs57();
  }

  operacionCs57(): void {
    const cas54 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_54, true);
    const cas56 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_56, true);
    const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas54, cas56, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSuma, "0") ? "0" : resultadoSuma;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_57 = valorRedondeado;
    //this.operacionCs91();
  }

  operacionCs61(): void {
    const camposResta = ['cs_id_59', 'cs_id_60'];
    const cas58 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_58, true);
    const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas58, resultadoCamposResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_61 = valorRedondeado;
    if(this.declaracionSugerida && this.declaracionSugerida.valSugeridoCasilla67 !='0')
    {
      const cas66 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_66, true);
      const cas67 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_67, true);
      const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas66, cas67, true);
      const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
      this.modelo.doc.cuerpo.cs_id_68 = valorRedondeado;
    }
    this.operacionCs69();
  }

  operacionCs65(): void {
    const cas63 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_63, true);
    const cas64 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_64, true);
    const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas63, cas64, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
    this.modelo.doc.cuerpo.cs_id_65 = valorRedondeado;
    this.operacionCs69();
  }

  operacionCs68(): void {
    const cas66 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_66, true);
    const cas67 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_67, true);
    const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas66, cas67, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
    this.modelo.doc.cuerpo.cs_id_68 = valorRedondeado;
    this.operacionCs69();
  //  this.operacionCs55();
  }

  operacionCs69(): void {
    const cas65 = this.modelo.doc.cuerpo.cs_id_65;
    const cas68 = this.modelo.doc.cuerpo.cs_id_68;
    const suma65_68 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas65, cas68, true);
    const cas61 = this.modelo.doc.cuerpo.cs_id_61;
    const cas62 = this.modelo.doc.cuerpo.cs_id_62;
    const suma61_62 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas61, cas62, true);
    const cas266 = this.modelo.doc.cuerpo.cs_id_266;

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, suma65_68, "0")) {
      this.modelo.doc.cuerpo.cs_id_69 = "0";
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma65_68, suma61_62)) {
      this.modelo.doc.cuerpo.cs_id_69 = suma65_68;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma65_68, suma61_62)) {
      this.modelo.doc.cuerpo.cs_id_69 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma61_62, cas266) ? suma61_62 : cas266;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma65_68, suma61_62)) {
      this.modelo.doc.cuerpo.cs_id_69 = cas266;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma65_68, suma61_62)) {
      this.modelo.doc.cuerpo.cs_id_69 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma61_62, cas266) ? suma61_62 : cas266;
    }
    this.operacionCs70();
    this.operacionCs265();
  }

  operacionCs70(): void {
    const camposSuma = ['cs_id_58', 'cs_id_62'];
    const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const camposResta = ['cs_id_59', 'cs_id_60', 'cs_id_69'];
    const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, resultadoCamposResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_70 = valorRedondeado;
    this.operacionCs71();
  }

  operacionCs71(): void {
    const camposSuma = ['cs_id_59', 'cs_id_60'];
    const camposResta = ['cs_id_58', 'cs_id_62'];
    const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposSuma, resultadoCamposResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_71 = valorRedondeado;
    this.operacionCs72();
    this.operacionCs73();
  }

  operacionCs72(): void {
    const cas70 = this.modelo.doc.cuerpo.cs_id_70;
    const cas72 = this.modelo.doc.cuerpo.cs_id_72;
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, cas72, cas70) ? cas70 : cas72 ;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_72 = valorRedondeado;
  }

  operacionCs73(): void {
    const cas70 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_70, true);
    const cas72 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_72, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas70, cas72, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_73 = valorRedondeado;
   // this.operacionCs91();
  }

  operacionCs78(): void {
    const camposResta = ['cs_id_75', 'cs_id_76', 'cs_id_77'];
    const cas74 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_74, true);
    const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas74, resultadoCamposResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_78 = valorRedondeado;
    if(this.declaracionSugerida && this.declaracionSugerida.valSugeridoCasilla84 !='0')
    {
     const cas83 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_83, true);
     const cas84 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_84, true);
     const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas83, cas84, true);
     const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
     this.modelo.doc.cuerpo.cs_id_85 = valorRedondeado;
    }
    this.operacionCs86();
  }

  operacionCs79(): void {
    this.operacionCs270();
    this.operacionCs86();
  }

  operacionCs82(): void {
    const cas80 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_80, true);
    const cas81 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_81, true);
    const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas80, cas81, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
    this.modelo.doc.cuerpo.cs_id_82 = valorRedondeado;
    this.operacionCs86();
  }

  operacionCs85(): void {
    const cas83 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_83, true);
    const cas84 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_84, true);
    const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas83, cas84, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
    this.modelo.doc.cuerpo.cs_id_85 = valorRedondeado;
    this.operacionCs86();
  }

  operacionCs86(): void {
    const cas82 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_82);
    const cas85 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_85);
    const suma82_85 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas82, cas85, true);
    const cas78 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_78);
    const cas79 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_79);
    const suma78_79 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas78, cas79, true);
    const cas267 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_267);

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, suma82_85, "0")) {
      this.modelo.doc.cuerpo.cs_id_86 = "0";
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma82_85, suma78_79)) {
      this.modelo.doc.cuerpo.cs_id_86 = suma82_85;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma82_85, suma78_79)) {
      this.modelo.doc.cuerpo.cs_id_86 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma78_79, cas267) ? suma78_79 : cas267;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma82_85, suma78_79)) {
      this.modelo.doc.cuerpo.cs_id_86 = cas267;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma82_85, suma78_79)) {
      this.modelo.doc.cuerpo.cs_id_86 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma78_79, cas267) ? suma78_79 : cas267;
    }

    this.operacionCs87();
    this.operacionCs265();
  }

  operacionCs87(): void {
    const camposSuma = ['cs_id_74', 'cs_id_79'];
    const camposResta = ['cs_id_75', 'cs_id_76', 'cs_id_77', 'cs_id_86'];
    const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposSuma, resultadoCamposResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_87 = valorRedondeado;
    this.operacionCs88();
  }

  operacionCs88(): void {
    const camposSuma = ['cs_id_75', 'cs_id_76', 'cs_id_77'];
    const camposResta = ['cs_id_74', 'cs_id_79'];
    const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const resultadoCamposResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposSuma, resultadoCamposResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_88 = valorRedondeado;
    this.operacionCs89();
 //   this.operacionCs90();
  }

  operacionCs89(): void {
    const cas87 = this.modelo.doc.cuerpo.cs_id_87;
    const cas89 = this.modelo.doc.cuerpo.cs_id_89;
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, cas89, cas87) ? cas87 : cas89 ;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_89 = valorRedondeado;
    this.operacionCs90();
  }

  operacionCs90(): void {
    const cas87 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_87, true);
    const cas89 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_89, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas87, cas89, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_90 = valorRedondeado;
   // this.operacionCs91();
  }

  operacionCs91(): void {
    const camposSuma = ['cs_id_41', 'cs_id_42', 'cs_id_53', 'cs_id_57', 'cs_id_69', 'cs_id_73', 'cs_id_86', 'cs_id_90'];
    const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoCamposSuma, true);
    this.modelo.doc.cuerpo.cs_id_91 = valorRedondeado;
    this.operacionCs92();
  }

  operacionCs92(): void {
    this.operacionCs316();
    this.operacionCs139();
    let valorRedondeado = '0';
    const porcentaje297 = '0.01';
    const valoruvt240 = '240';
    let valorcasillaOperacion297 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelo.doc.cuerpo.cs_id_297, porcentaje297);
    let valorcasillaOperacion297p = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelo.doc.cuerpo.cs_id_297, porcentaje297);
    const UVT240 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valoruvt240, this.UVT);
    const mayorque = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valorcasillaOperacion297, UVT240);

    if (mayorque) valorcasillaOperacion297 = UVT240;
    let valoredondeado28 = this.dutilidades.redondearValorMoneda(valorcasillaOperacion297p, true);
    
    
    const mayorque1 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valoredondeado28, UVT240);
    if (mayorque1) valoredondeado28 = UVT240;
    this.modelo.doc.cuerpo.cs_id_28 = valoredondeado28;
    const camposSuma = ['cs_id_41', 'cs_id_53', 'cs_id_69', 'cs_id_86','cs_id_28','cs_id_139'];
    let resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoCamposSuma, true);
    
    const cas91 =this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_91, true);
    const mayorque2 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, valorRedondeado, cas91);
    if (mayorque2) this.modelo.doc.cuerpo.cs_id_92 = cas91;
    else this.modelo.doc.cuerpo.cs_id_92 = valorRedondeado;
    this.operacionCs93();
  }

  operacionCs93(): void {
    const cas91 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_91, true);
    const cas92 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_92, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas91, cas92, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_93 = valorRedondeado;
    this.operacionCs97();
  }

  operacionCs94(): void {
    const cas93 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_93, true);
    const cas94 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_94, true);
    const cas42 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_42, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas93, cas42, true);
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas94, resultadoResta)) {
      this._notifications.showError("El valor de la casilla 94 no puede superar el valor de la casilla 93 menos la casilla 42");
      this.modelo.doc.cuerpo.cs_id_94 = "0";
    }
    this.operacionCs97();
  }

  operacionCs95(): void {
    const cas93 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_93, true);
    const cas94 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_94, true);
    const cas95 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_95, true);
    const resta93_94 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas93, cas94, true);
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resta93_94, cas95)) {
      this._notifications.showError("El valor de la casilla 95 no puede superar el valor de la casilla 93 menos la casilla 94");
      this.modelo.doc.cuerpo.cs_id_95 = "0";
    }
    this.operacionCs97();
  }

  operacionCs97(): void {
    const camposSumaPrin = ['cs_id_93', 'cs_id_96'];
    const cas94 = this.modelo.doc.cuerpo.cs_id_94;
    const cas95 = this.modelo.doc.cuerpo.cs_id_95;
    const resultadoCamposSumaprin = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaPrin, true);
    const resultadoCamposResta1 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposSumaprin, cas94, true);
    const resultadoCamposResta2 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposResta1, cas95, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoCamposResta2, "0") ? "0" : resultadoCamposResta2;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_97 = valorRedondeado;
    //this.operacionCs101();

}

  operacionCs101(): void {
    const cas99 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_99, true);
    const cas100 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_100, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas99, cas100, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_101 = valorRedondeado;
    this.operacionCs103();
  }

  operacionCs102(): void {
    const cas102 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_102, true);
    const cas101 =  this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_101, true);
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas102, cas101) ){
      this.dNotificacionServicio.mostrarDialogoInformacion("Señor contribuyente recuerde que el Limite de las rentas exentas por ingresos de pension por año no debe superar la renta líquida. El valor ingresado en esta casilla será ajustado al tope máximo permitido.");
      this.modelo.doc.cuerpo.cs_id_102 = this.modelo.doc.cuerpo.cs_id_101;
    }
    this.operacionCs103();
  }

  operacionCs103(): void {
    const cas101 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_101, true);
    const cas102 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_102, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas101, cas102, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_103 = valorRedondeado;
    //this.operacionCs108();
  //  this.operacionCs111();
  }

  operacionCs106(): void {
    const cas104 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_104, true);
    const cas105 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_105, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas104, cas105, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_106 = valorRedondeado;
    this.operacionCs108();
    this.operacionCs118();
  }

  operacionCs108(): void {
      const camposSumaDivi = ['cs_id_305', 'cs_id_308', 'cs_id_311', 'cs_id_314', 'cs_id_318', 'cs_id_321', 'cs_id_324', 'cs_id_327', 'cs_id_330', 'cs_id_333'];
      const resultadoCamposSumaDiv = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaDivi, true);
      const camposSumaImpuestos= ['cs_id_306', 'cs_id_309', 'cs_id_312', 'cs_id_315', 'cs_id_317', 'cs_id_320', 'cs_id_323', 'cs_id_326', 'cs_id_329', 'cs_id_332'];
      const resultadoCamposSumaImp = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaImpuestos, true);
      //const valorRedondeadoImp = this.dutilidades.redondearValorMoneda(resultadoCamposSumaImp);
      const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoCamposSumaDiv);
     // const resta111 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, valorRedondeado, valorRedondeadoImp, true);
     // this.modelo.doc.cuerpo.cs_id_111 = resta111;
      this.modelo.doc.cuerpo.cs_id_108 = valorRedondeado;
    //  this.operacionCs118();
     // this.operacionCs120();
      this.operacionCs111();
   
  }
  operacionCs111(): void {
    const cas97 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_97);
    const cas98 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_98);
    const cas103 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_103);
    const cas107 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_107);
    const cas298 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_298);
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas97, cas98)) {
      const camposSuma= ['cs_id_97','cs_id_103','cs_id_107','cs_id_298'];
      const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
      let resultado = this.dutilidades.redondearValorMoneda(resultadoCamposSuma,true);
      this.modelo.doc.cuerpo.cs_id_111 = resultado;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas98, cas97))  
    {
      const camposSuma= ['cs_id_98','cs_id_103','cs_id_107','cs_id_298'];
      const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
      let resultado = this.dutilidades.redondearValorMoneda(resultadoCamposSuma,true);
      this.modelo.doc.cuerpo.cs_id_111 = resultado;
    } else {
      const camposSuma= ['cs_id_97','cs_id_103','cs_id_107','cs_id_298'];
      const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
      let resultado = this.dutilidades.redondearValorMoneda(resultadoCamposSuma,true);
      this.modelo.doc.cuerpo.cs_id_111 = resultado;
    }
  //  this.operacionCs116();
  }
  public mensajeCs108()
  { 
    //this.operacionCs121();
    this.booCas108Clic = true;
    this.dNotificacionServicio.mostrarDialogoConfirmacion('Para diligenciar el valor de la casilla 108 debe incluir los valores según lo requiera en las casillas  304, 305, 307, 308, 310, 311, 313, 314,  318, 319,  321, 322, 324, 325, 327, 328,  330,  331, 333,  334, en la siguiente pestaña');  
    return;
  }


  operacionCs114(): void {
    this.operacionCs270();
    let cas112 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_112,true);
    let cas113 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_113,true);
    let cas114 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_114,true);
    let cas274 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_274,true);
    let resta112_114 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas112, cas113, true);

    resta112_114  = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resta112_114, "0") ? "0" : resta112_114;
    
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas274, "0")){
      if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas114, "0")){
          this.dNotificacionServicio.mostrarDialogoError("Recuerde que  si en el periodo determinó pérdidas por ganancias ocasionales NO es procedente incluir en esta casilla ganancias ocasionales no gravadas y exentas, en caso de no tener pérdidas el valor incluido debe ser menor al valor de restar los costos al valor de  los ingresos");
          this.modelo.doc.cuerpo.cs_id_114 = "0"; 
        }
      }else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas274, "0") && (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas114, resta112_114))){
        this.dNotificacionServicio.mostrarDialogoError("El valor de la casilla 114 no puede superar el valor de la casilla 112 menos la casilla 113");
        this.modelo.doc.cuerpo.cs_id_114 = "0";
      }
    this.operacionCs115();
  }

  operacionCs115(): void {
    const cas112 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_112);
    const camposSuma= ['cs_id_113','cs_id_114'];
    const resultadoCamposSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const resultadoCamposResta =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas112, resultadoCamposSuma, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoCamposResta, "0")?"0":resultadoCamposResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_115 = valorRedondeado;
    this.operacionCs116();
    //this.operacionCs127();
  }

  operacionCs116(): void {

    const cas97 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_97);
    const cas98 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_98);
    const cas103 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_103);

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas97, cas98)) {
      const resultadoSuma = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_111); //this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas97, cas103, true);
      const valorEnUvt = this.convertirPesosUvt(resultadoSuma);
      let resultado = this.aplicarTablaArt241ET(valorEnUvt, this.rangosArt241ET);
      resultado = this.dutilidades.redondearValorMoneda(resultado, true);
      this.modelo.doc.cuerpo.cs_id_116 = resultado;
   } else if ((this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas97, "0")) && 
    (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas98, "0"))) {
      const resultadoSuma = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_111); //this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas97, cas103, true);
      const valorEnUvt = this.convertirPesosUvt(resultadoSuma);
      let resultado = this.aplicarTablaArt241ET(valorEnUvt, this.rangosArt241ET);
      resultado = this.dutilidades.redondearValorMoneda(resultado, true);
      this.modelo.doc.cuerpo.cs_id_116 = resultado;
    }
   else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas97, cas98)) {
    const resultadoSuma = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_111); //this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas97, cas103, true);
    const valorEnUvt = this.convertirPesosUvt(resultadoSuma);
    let resultado = this.aplicarTablaArt241ET(valorEnUvt, this.rangosArt241ET);
    resultado = this.dutilidades.redondearValorMoneda(resultado, true);
    this.modelo.doc.cuerpo.cs_id_116 = resultado;
  }
    else {
      this.modelo.doc.cuerpo.cs_id_116 = "0";
    }
    this.operacionCs117();
  }

  operacionCs117(): void {
    const cas97 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_97);
    const cas98 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_98);
    const cas103 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_103);

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas98, cas97)) {
      let resultadoCamposSumasec = "0";
      
      const cas111= this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_111);
      const valorEnUvt = this.convertirPesosUvt(cas111);
      let resultado = this.aplicarTablaArt241ET(valorEnUvt, this.rangosArt241ET);
      resultado = this.dutilidades.redondearValorMoneda(resultado, true);
      this.modelo.doc.cuerpo.cs_id_117 = resultado;
    } else {
      this.modelo.doc.cuerpo.cs_id_117 = "0";
    }
    this.operacionCs119(true);
  }

  operacionCs118(): void {
    const camposSumaRDivi = ['cs_id_306', 'cs_id_309', 'cs_id_312', 'cs_id_315', 'cs_id_317', 'cs_id_320', 'cs_id_323', 'cs_id_326', 'cs_id_329', 'cs_id_332'];
    const resultadoCamposSumaRDiv = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaRDivi, true);
    let resultado = this.dutilidades.redondearValorMoneda(resultadoCamposSumaRDiv, true);
    this.modelo.doc.cuerpo.cs_id_118 = resultado; 
 
  }

  operacionCs119(booCalcula:Boolean): void {

    let cas106 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_106);
    let valorEnUvt = this.convertirPesosUvt(cas106);
    let resultado = this.aplicarTablaArt241ET(valorEnUvt, this.rangosArt241ETNumeral2);
    resultado = this.dutilidades.redondearValorMoneda(resultado, true);
    this.modelo.doc.cuerpo.cs_id_119 = resultado;
    this.operacionCs120();
    if(!booCalcula)
    {
      this.operacionCs111();
    }

  }

  operacionCs120(): void {
     
      const cas109 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_109);
      const cas110 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_110);
      const suma109_110 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas109, cas110, true);
      const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma109_110, "0") ? "0" : suma109_110;
      const valC = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoOperacion, this.tarifaA);
      const valorRedondeado = this.dutilidades.redondearValorMoneda(valC, true);
      this.modelo.doc.cuerpo.cs_id_120 = valorRedondeado;
      
    
      this.operacionCs121();
      this.operacionCs296();
     
  }

  operacionCs121(): void {
    const camposSuma = ['cs_id_116','cs_id_117','cs_id_118','cs_id_119', 'cs_id_120'];
    const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
    this.modelo.doc.cuerpo.cs_id_121 = valorRedondeado;

    this.operacionCs123();
  }

  operacionCs122(): void {
    const cas122 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_122);
    const cas121 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_121);
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas122, cas121)) {
      this._notifications.showError("El valor de la casilla 122 no puede superar el valor de la casilla 121");
      this.modelo.doc.cuerpo.cs_id_122 = "0";
    }
    this.operacionCs123();
  }

  operacionCs123(): void {
    const cas116 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_116);
    const cas117 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_117);
    const cas121 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_121);
    const cas123 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_123);
    const Cas121x30porCien = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas121, '0.30');
    const Cas121x25porCien = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas121, '0.25');
    this.modelo.doc.cuerpo.cs_id_123 = cas123;

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas116, cas117) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas123, Cas121x30porCien)) {
      this.modelo.doc.cuerpo.cs_id_123 = Cas121x30porCien;
      this._notifications.showError("El valor de la casilla 123 no puede superar 30% del valor de la casilla 121");
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas117, cas116) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas123, Cas121x25porCien)) {
      this.modelo.doc.cuerpo.cs_id_123 = Cas121x25porCien;
      this._notifications.showError("El valor de la casilla 123 no puede superar 25% del valor de la casilla 121");
    } else {
      this.operacionCs124();
    }
  }

  operacionCs124(modificaUsuario?:boolean): void {
      const cas124=this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_124);
      const cas296=this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_296);
     
      if(cas124=='0' || (!modificaUsuario && !this.boolfinal))
      {
        this.modelo.doc.cuerpo.cs_id_124 = this.modelo.doc.cuerpo.cs_id_296;
      }
      else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas296, cas124))
      {
       // this._notifications.showError("El valor de la casilla 124 no puede ser inferior al valor de la casilla 296");
        this.modelo.doc.cuerpo.cs_id_124 = this.modelo.doc.cuerpo.cs_id_296;
      }
     
      this.operacionCs125();
  }

  operacionCs125(): void {
    const cas116 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_116);
    const cas117 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_117);
    const cas121 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_121);
    const camposSuma = ['cs_id_122', 'cs_id_123', 'cs_id_124'];
    const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
    const cas125 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_125);
    const Cas121x25porCien = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas121, '0.25');
    this.modelo.doc.cuerpo.cs_id_125 = valorRedondeado;

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas116, cas117) &&
      this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas125, cas121)) {
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, resultadoSuma, cas121)) {
        this._notifications.showError("El valor de la casilla 125 no puede superar el valor de la casilla 121");
        let valorRedondeado = this.dutilidades.redondearValorMoneda(cas121, true);
        this.modelo.doc.cuerpo.cs_id_125 = valorRedondeado;
      }
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas117, cas116) &&
      this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas125, Cas121x25porCien)) {
      this._notifications.showError("El valor de la casilla 125 no puede superar 25% del valor de la casilla 121");
      let valorRedondeado = this.dutilidades.redondearValorMoneda(Cas121x25porCien, true);
      this.modelo.doc.cuerpo.cs_id_125 = valorRedondeado;
    }
    this.operacionCs126();
  }

  operacionCs126(): void {
    const cas121 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_121, true);
    const cas125 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_125, true);
    const cas126 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_126, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas121, cas125, true);
    let resultadoOperacion='0';
    if(this.boolfinal)
    {
      const resultadoValidacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, cas126) ? cas126 : resultadoResta;
      resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoValidacion, "0") ? "0" : resultadoValidacion;
    }
    else
    {
      resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    }
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_126 = valorRedondeado;
    this.operacionCs127();
    //this.operacionCs129();
  }
  

  operacionCs127(): void {
    const cas115 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_115);
    const cas115VeintePorciento = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas115, '0.2');

   // const cas114 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_114);
    const cas115QuincePorciento = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas115, '0.14');

    const cas127 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_127);

    let resultadoOperacion=cas127;

    if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas127,cas115QuincePorciento)) 
    {
      resultadoOperacion=this.dutilidades.redondearValorMoneda(cas115VeintePorciento);
    }
    else
     if ( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE,  cas127, cas115VeintePorciento))
     {
      resultadoOperacion=this.dutilidades.redondearValorMoneda(cas115VeintePorciento);
     }
    
    this.modelo.doc.cuerpo.cs_id_127 = this.dutilidades.redondearValorMoneda(resultadoOperacion);
    this.operacionCs129();
  }

  operacionCs129(): void {
    const camposSuma = ['cs_id_126', 'cs_id_127'];
    const cas128 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_128);
    const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, cas128, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_129 = valorRedondeado;
    this.operacionCs134();
  }

  operacionCs134(): void {
    const camposSuma = ['cs_id_129', 'cs_id_133'];
    const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const camposResta = ['cs_id_130', 'cs_id_131', 'cs_id_132'];
    const resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const RestaGlobal = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, resultadoResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, RestaGlobal, "0") ? "0" : RestaGlobal;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_134 = valorRedondeado;
    //this.extemporaneidad.esExtemporaneo=false;
    this.operacionCs136();
  }

  operacionCs136(): void {
    const camposSuma = ['cs_id_129', 'cs_id_133', 'cs_id_135'];
    const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const camposResta = ['cs_id_130', 'cs_id_131', 'cs_id_132'];
    const resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const RestaGlobal = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, resultadoResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, RestaGlobal, "0") ? "0" : RestaGlobal;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_136 = valorRedondeado;
    this.operacionCs137();
  }

  operacionCs137(): void {
    const camposSuma = ['cs_id_130', 'cs_id_131', 'cs_id_132'];
    const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const camposResta = ['cs_id_129', 'cs_id_133', 'cs_id_135'];
    const resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const RestaGlobal = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, resultadoResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, RestaGlobal, "0") ? "0" : RestaGlobal;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_137 = valorRedondeado;
  }

  
  operacionCs242(): void {
    this.modelo.doc.cuerpo.cs_id_335 = '0'; 
    const cas355=Number(this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_355));
    if(cas355>0 ||  Number(this.modelo.doc.cuerpo.cs_id_43)>0  )
    {
      this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"¿Desea aplicar un dependiente económico como deducción?").afterClosed().subscribe(result => {
        if (result) this.modelo.doc.cuerpo.cs_id_335 = '1';
        this.operacionCs91();
      });
    }
    
  }

  operacionCs265(): void {
    const cas273 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_273, true);
    const cas41 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_41, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas273, cas41, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_265 = valorRedondeado;

    const cas46 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_46);
    const cas49 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_49);
    const cas52 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_52);
    const cas265 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_265);
    const suma49_52 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas49, cas52, true);

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma49_52, "0")) {
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma49_52, cas46)) {
        this.temporal53 = suma49_52;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma49_52, cas46)) {
        this.temporal53 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas46, cas265) ? cas46 : cas265;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma49_52, cas46)) {
        this.temporal53 = cas265;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma49_52, cas265) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma49_52, cas46)) {
        this.temporal53 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas46, cas265) ? cas46 : cas265;;
      }
    }
    this.operacionCs266();
  }

  operacionCs266(): void {
    const cas265 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_265, true);
    const cas53 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_53, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas265, cas53, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_266 = valorRedondeado;

    const cas61 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_61); //RENTA LIQUIDA
    const cas62 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_62); //RENTA LIQUIDA
    const cas65 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_65); //RENTAS EXCENTAS	
    const cas68 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_68); //DEDUCIONES IMPUTABLES
    const cas266 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_266);
    const suma61_62 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas61, cas62, true); //RENTAS LIQUIDAS PASIVAS
    const suma65_68 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas65, cas68, true); //RENTAS EXCENTAS

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma65_68, "0")) {
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma65_68, suma61_62)) {
        this.temporal69 = suma65_68;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma65_68, suma61_62)) {
        this.temporal69 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma61_62, cas266) ? suma61_62 : cas266;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma65_68, suma61_62)) {
        this.temporal69 = cas266;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma65_68, cas266) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma65_68, suma61_62)) {
        this.temporal69 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma61_62, cas266) ? suma61_62 : cas266;
      }
    }
    this.operacionCs267();
  }

  operacionCs267(): void {
    const cas266 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_266, true);
    const cas69 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_69, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas266, cas69, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_267 = valorRedondeado;

    const cas78 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_78); //RENTA LIQUIDA
    const cas79 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_79); //RENTA LIQUIDA
    const cas82 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_82); //RENTAS EXCENTAS	
    const cas85 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_85); //DEDUCIONES IMPUTABLES
    const cas267 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_267);
    const suma78_79 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas78, cas79, true); //RENTAS LIQUIDAS PASIVAS
    const suma82_85 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas82, cas85, true); //RENTAS EXCENTAS

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma82_85, "0")) {
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma82_85, suma78_79)) {
        this.temporal86 = suma82_85;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma82_85, suma78_79)) {
        this.temporal86 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma82_85, cas267) ? suma78_79 : cas267;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma78_79, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma82_85, suma78_79)) {
        this.temporal86 = cas267;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma82_85, cas267) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma82_85, suma78_79)) {
        this.temporal86 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma78_79, cas267) ? suma78_79 : cas267;
      }
    }
  }

  operacionCs270(): void {
    const camposSuma = ['cs_id_32', 'cs_id_43', 'cs_id_58', 'cs_id_74'];
    const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const camposResta = ['cs_id_33', 'cs_id_44', 'cs_id_59', 'cs_id_76'];
    const resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const RestaGlobal = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoSuma, resultadoResta, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, RestaGlobal, "0") ? "0" : RestaGlobal;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_270 = valorRedondeado;
    this.operacionCs271();
  }

  operacionCs271(): void {
    ////modificado 09-04-2024 tutela
    
    const camposPrimeraSuma = ['cs_id_270', 'cs_id_62', 'cs_id_79'];
    const resultadoPrimeraSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposPrimeraSuma, true);
    const primerFactorx40porCien = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoPrimeraSuma, '0.40');
    
    const camposSuma = ['cs_id_246', 'cs_id_248', 'cs_id_250', 'cs_id_252', 'cs_id_254', 'cs_id_256', 'cs_id_276', 'cs_id_278', 'cs_id_280', 'cs_id_281'];
    const segundoFactor = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    
    const resultadoSumaFactores = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, primerFactorx40porCien, segundoFactor, true);
    
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSumaFactores, "0") ? "0" : resultadoSumaFactores;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_271 = valorRedondeado;
    
    
    /*const camposPrimeraSuma = ['cs_id_270', 'cs_id_62', 'cs_id_79'];
    const resultadoPrimeraSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposPrimeraSuma, true);
    const camposResta = ['cs_id_246', 'cs_id_248', 'cs_id_250', 'cs_id_252', 'cs_id_254', 'cs_id_256', 'cs_id_276', 'cs_id_278', 'cs_id_280', 'cs_id_281'];
    const resultadoResta = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposResta, true);
    const primerFactor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoPrimeraSuma, resultadoResta, true);
    const primerFactorx40porCien = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, primerFactor, '0.40');
    const camposSuma = ['cs_id_246', 'cs_id_248', 'cs_id_250', 'cs_id_252', 'cs_id_254', 'cs_id_256', 'cs_id_276', 'cs_id_278', 'cs_id_280', 'cs_id_281'];
    const segundoFactor = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    const resultadoSumaFactores = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, primerFactorx40porCien, segundoFactor, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoSumaFactores, "0") ? "0" : resultadoSumaFactores;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    this.modelo.doc.cuerpo.cs_id_271 = valorRedondeado;
    */
    
    this.operacionCs272();
  }

  operacionCs272(): void {
    let uvtDefecto = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.UVT, '1340');
    const camposSuma = ['cs_id_246', 'cs_id_248', 'cs_id_250', 'cs_id_252', 'cs_id_254', 'cs_id_256', 'cs_id_276', 'cs_id_278', 'cs_id_280', 'cs_id_281'];
    let resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);
    resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultadoSuma, uvtDefecto);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
    this.modelo.doc.cuerpo.cs_id_272 = valorRedondeado;
    this.operacionCs273();
  }

  operacionCs273(): void {

    const cas270 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_270, true);
    const cas271 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_271, true);
    const cas272 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_272, true);

    const cas270Menorq271 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas270, cas271);
    const cas270Menorq272 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas270, cas272);
    const cas270Mayorq271 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas270, cas271);
    const cas270Mayorq272 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas270, cas272);
    const cas270Iguala271 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas270, cas271);
    const cas270Iguala272 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas270, cas272);
    const cas271Menorq272 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas271, cas272);
    const cas271Mayorq272 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas271, cas272);
    const cas270Menoigual272 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, cas270, cas272);

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas270, "0"))
      this.modelo.doc.cuerpo.cs_id_273 = "0";
    else if (cas270Menorq271 && cas270Menorq272)
      this.modelo.doc.cuerpo.cs_id_273 = cas270;
    else if (cas270Mayorq271 && cas270Menoigual272)
      this.modelo.doc.cuerpo.cs_id_273 = cas271;
    else if (cas270Mayorq271 && cas270Mayorq272 && cas271Menorq272)
      this.modelo.doc.cuerpo.cs_id_273 = cas271;
    else if (cas270Mayorq271 && cas270Mayorq272 && cas271Mayorq272)
      this.modelo.doc.cuerpo.cs_id_273 = cas272;
    else if (cas270Menorq271 && cas270Mayorq272)
      this.modelo.doc.cuerpo.cs_id_273 = cas272;
    else if (cas270Iguala271 && cas270Mayorq272)
      this.modelo.doc.cuerpo.cs_id_273 = cas272;
    else if (cas270Iguala271 && cas270Menorq272)
      this.modelo.doc.cuerpo.cs_id_273 = cas270;
    else if (cas270Menorq271 && cas270Iguala272)
      this.modelo.doc.cuerpo.cs_id_273 = cas272;
    else if (cas270Iguala271 && cas270Iguala272)
      this.modelo.doc.cuerpo.cs_id_273 = cas272;

    const cas34 = this.modelo.doc.cuerpo.cs_id_34;
    const cas37 = this.modelo.doc.cuerpo.cs_id_37;
    const cas40 = this.modelo.doc.cuerpo.cs_id_40;
    const cas273 = this.modelo.doc.cuerpo.cs_id_273;
    const suma37_40 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas37, cas40, true);

    //validar cambios
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma37_40, "0")) {
      if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma37_40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma37_40, cas34)) {
        this.temporal41 = suma37_40;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, suma37_40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma37_40, cas34)) {
        this.temporal41 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas34, cas273) ? cas34 : cas273;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma37_40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, suma37_40, cas34)) {
        this.temporal41 = cas273;
      } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, suma37_40, cas273) && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma37_40, cas34)) {
        this.temporal41 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas34, cas273) ? cas34 : cas273;
      }
    }
  }

  operacionCs274(): void {
      this.modelo.doc.cuerpo.cs_id_274 = "0";
      this.operacionCs115();
   
  }

  private operacionCs287() : void{
     this.contarDependientes();
     this.modelo.doc.cuerpo.cs_id_138=''+this.cuentadependientes;
     this.boolfinal=false;
    /* this.operacionCs91();
     this.operacionCs101();
     this.operacionCs106();
     this.operacionCs114();*/
   }
  operacionCs290(): void {
      
    this.contarDependientes();
    this.modelo.doc.cuerpo.cs_id_138=''+this.cuentadependientes;
    this.boolfinal=false;
   /* this.operacionCs91();
    this.operacionCs101();
    this.operacionCs106();
    this.operacionCs114();*/
  }

  operacionCs293(): void {
    this.contarDependientes();
    this.modelo.doc.cuerpo.cs_id_138=''+this.cuentadependientes;
    this.boolfinal=false;
   /* this.operacionCs91();
    this.operacionCs101();
    this.operacionCs106();
    this.operacionCs114();*/
  }
  operacionCs295(): void {
    this.contarDependientes(); 
    this.modelo.doc.cuerpo.cs_id_138=''+this.cuentadependientes;
    this.boolfinal=false;
   /* this.operacionCs91();
    this.operacionCs101();
    this.operacionCs106();
    this.operacionCs114();*/
  }
  operacionCs358()
  {
    const cas358=this.modelo.doc.cuerpo.cs_id_358;

    const cas242=this.modelo.doc.cuerpo.cs_id_242;
    const cas288=this.modelo.doc.cuerpo.cs_id_288;
    const cas291=this.modelo.doc.cuerpo.cs_id_291;
    const cas294=this.modelo.doc.cuerpo.cs_id_294;
    let boolBuscaDependientes=false;
    if (this.modelo.doc.cuerpo.cs_id_358 != null && this.modelo.doc.cuerpo.cs_id_358 != "") 
    {
      if(cas358==cas242) boolBuscaDependientes=true;
      else if(cas358==cas288) boolBuscaDependientes=true;
      else if(cas358==cas291) boolBuscaDependientes=true;
      else if(cas358==cas294) boolBuscaDependientes=true;
    }
    else
    {
      boolBuscaDependientes=true; 
    }
    if(!boolBuscaDependientes)
     this._notifications.showError(MESSAGES.DEPENDIENTE);
    
     return boolBuscaDependientes;

  }
  operacionCs359()
  {
    if (this.modelo.doc.cuerpo.cs_id_357 != null && this.modelo.doc.cuerpo.cs_id_358 != null && this.modelo.doc.cuerpo.cs_id_359 != null &&
      this.modelo.doc.cuerpo.cs_id_357 != "" && this.modelo.doc.cuerpo.cs_id_358 != "" && this.modelo.doc.cuerpo.cs_id_359 != ""
      && this.modelo.doc.cuerpo.cs_id_357 != "0" && this.modelo.doc.cuerpo.cs_id_358 != "0"  && this.modelo.doc.cuerpo.cs_id_359 != "0"
      && this.modelo.doc.cuerpo.cs_id_358.length>3) {
      this.contarDependientes();
      this.modelo.doc.cuerpo.cs_id_138=''+this.cuentadependientes;
    }
    else {

      this._notifications.showError("El valor de las casillas 357,358 y 359 no es un dependiente valido");
      this.modelo.doc.cuerpo.cs_id_357 ="";
      this.modelo.doc.cuerpo.cs_id_358 ="";
      this.modelo.doc.cuerpo.cs_id_359 ="";
      //this.habilitaDependiente2 = true;

    }
   // this.operacionCs91();

  }

  operacionCs296(): void {
     // const resultado1090UVT = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, '1090', this.UVT);
      
      //Modificación solicitada 27-03-2025
  
    const cas107UVT= this.convertirPesosUvt(this.modelo.doc.cuerpo.cs_id_107);
    const cas108UVT= this.convertirPesosUvt(this.modelo.doc.cuerpo.cs_id_108);
    const cas118UVT= this.convertirPesosUvt(this.modelo.doc.cuerpo.cs_id_118);
    
    const suma107_108 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas107UVT, cas108UVT, false);
    const resta118 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, suma107_108, cas118UVT, false);
      /*const camposSumaDivi = ['cs_id_107', 'cs_id_108'];
      const resultadoCamposSumaDiv = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaDivi, true);
      const cas118=this.modelo.doc.cuerpo.cs_id_118;
      let letCasilla296 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resultadoCamposSumaDiv, cas118, true);
      
      letCasilla296 = this.dutilidades.deshacerFormatoMoneda(letCasilla296);
      if (Number(resultado1090UVT) < Number(letCasilla296)) {
      */
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, resta118, "1090")) {
        let resultadoCasilla296 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, resta118, '1090');
        resultadoCasilla296 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoCasilla296, '0.19');
        const resultadoCasilla296SinUVT= this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, resultadoCasilla296, this.UVT);
        this.modelo.doc.cuerpo.cs_id_296 = this.dutilidades.redondearValorMoneda(resultadoCasilla296SinUVT, true);
      }
      else {
        this.modelo.doc.cuerpo.cs_id_296 = '0';
      }
      
   
    this.operacionCs124();
  }

  operacionCs298(): void {
    let casilla303 ='0';
    let resultadoCasilla298 = '0';
    const cas118=this.modelo.doc.cuerpo.cs_id_118;
    const cas108=this.modelo.doc.cuerpo.cs_id_108;
    resultadoCasilla298 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas108, cas118);
    this.modelo.doc.cuerpo.cs_id_298 = resultadoCasilla298;
    if (this.modelo.doc.cuerpo.cs_id_43 != null && this.modelo.doc.cuerpo.cs_id_43 != '') {
      const casilla45 = this.modelo.doc.cuerpo.cs_id_45;
      const casilla43 = this.modelo.doc.cuerpo.cs_id_43;

      if (this.modelo.doc.cuerpo.cs_id_43 != '0')
        casilla303 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION, casilla45, casilla43);
    }

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, casilla303, "0.6"))
      this.booTopeindicativo = true;
    else this.booTopeindicativo = false;
    let dosDecCasilla303 =casilla303.substring(0,4);
    this.modelo.doc.cuerpo.cs_id_303 = dosDecCasilla303;
    
  }

  operacionCs316(): void {
    this.modelo.doc.cuerpo.cs_id_316 = 0;
  
  }
  operacionCs139(): void {
    this.modelo.doc.cuerpo.cs_id_139 = 0;
      const valoruvt72 = '72';
      const UVT72 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, valoruvt72, this.UVT);
      if ((this.modelo.doc.cuerpo.cs_id_32 && this.modelo.doc.cuerpo.cs_id_32 != '0')
      || (this.modelo.doc.cuerpo.cs_id_43 && this.modelo.doc.cuerpo.cs_id_43 != '0'))
      {
            if( this.modelo.doc.cuerpo.cs_id_241 != null && this.modelo.doc.cuerpo.cs_id_242 != null  && this.modelo.doc.cuerpo.cs_id_244 != null &&
            this.modelo.doc.cuerpo.cs_id_241 != "" && this.modelo.doc.cuerpo.cs_id_242 != ""  && this.modelo.doc.cuerpo.cs_id_244 != "" 
            && this.modelo.doc.cuerpo.cs_id_241 != "0" && this.modelo.doc.cuerpo.cs_id_242 != "0"  && this.modelo.doc.cuerpo.cs_id_244 != "0"
            && this.modelo.doc.cuerpo.cs_id_242.length>3)
            {
              this.modelo.doc.cuerpo.cs_id_139 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_139, UVT72);
            }
          if (this.modelo.doc.cuerpo.cs_id_287 != null && this.modelo.doc.cuerpo.cs_id_288 != null && this.modelo.doc.cuerpo.cs_id_289 != null &&
            this.modelo.doc.cuerpo.cs_id_287 != "" && this.modelo.doc.cuerpo.cs_id_288 != "" && this.modelo.doc.cuerpo.cs_id_289 != ""
            && this.modelo.doc.cuerpo.cs_id_287 != "0" && this.modelo.doc.cuerpo.cs_id_288 != "0" && this.modelo.doc.cuerpo.cs_id_289 != "0"
            && this.modelo.doc.cuerpo.cs_id_288.length>3) 
            {
              this.modelo.doc.cuerpo.cs_id_139 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_139, UVT72);
            }
          if (this.modelo.doc.cuerpo.cs_id_290 != null && this.modelo.doc.cuerpo.cs_id_291 != null && this.modelo.doc.cuerpo.cs_id_292 != null &&
              this.modelo.doc.cuerpo.cs_id_290 != "" && this.modelo.doc.cuerpo.cs_id_291 != "" && this.modelo.doc.cuerpo.cs_id_292 != ""
              && this.modelo.doc.cuerpo.cs_id_290 != "0" && this.modelo.doc.cuerpo.cs_id_291 != "0" && this.modelo.doc.cuerpo.cs_id_292 != "0"
              && this.modelo.doc.cuerpo.cs_id_291.length>3) 
            {
              
              this.modelo.doc.cuerpo.cs_id_139 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_139, UVT72);
            }
          if (this.modelo.doc.cuerpo.cs_id_293 != null && this.modelo.doc.cuerpo.cs_id_294 != null && this.modelo.doc.cuerpo.cs_id_295 != null &&
              this.modelo.doc.cuerpo.cs_id_293 != "" && this.modelo.doc.cuerpo.cs_id_294 != "" && this.modelo.doc.cuerpo.cs_id_295 != ""
              && this.modelo.doc.cuerpo.cs_id_293 != "0" && this.modelo.doc.cuerpo.cs_id_294 != "0" && this.modelo.doc.cuerpo.cs_id_295 != "0"
              && this.modelo.doc.cuerpo.cs_id_294.length>3) 
            {
              this.modelo.doc.cuerpo.cs_id_139 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_139, UVT72);
                
            }
      }
   //   if (this.modelo.doc.cuerpo.cs_id_335 && this.modelo.doc.cuerpo.cs_id_335 == '1') {
    //    this.modelo.doc.cuerpo.cs_id_139 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, this.modelo.doc.cuerpo.cs_id_139, UVT72);
    //  }

      const camposSumaF = ['cs_id_42', 'cs_id_57','cs_id_41','cs_id_53'];
      let resultadoCamposSumaF = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaF, true);
      let valorRedondeado_42_57 = this.dutilidades.redondearValorMoneda(resultadoCamposSumaF, true);
      
      let cas139 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_139, true);
      const mayorque2 = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, cas139, valorRedondeado_42_57);
      if (mayorque2) this.modelo.doc.cuerpo.cs_id_139 = valorRedondeado_42_57;
      else this.modelo.doc.cuerpo.cs_id_139 = cas139;
    
  }

  operacionCs980(): void {
    if (this.firmaRequerida) this.modelo.doc.pie.cs_id_980 = "0";
    const cas137 = this.modelo.doc.cuerpo.cs_id_137;
    let cas980 = this.modelo.doc.pie.cs_id_980;
    const comparacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas137, cas980) ? true : false;
    if (comparacion) {
      this._notifications.showError("Señor contribuyente, el valor de la casilla 980 (Pago total) no puede superar la suma de los valores de las casillas 135 (Saldo a pagar por impuesto) y 136 (Sanciones)");
      this.modelo.doc.pie.cs_id_980 = "0";
      return;
    }
    cas980 = this.dutilidades.redondearValorMoneda(this.modelo.doc.pie.cs_id_980);
    const cas980quitarFormato = this.dutilidades.deshacerFormatoMoneda(cas980);
    this.modelo.doc.pie.cs_id_980 = String(cas980quitarFormato);
  }

  //Operaciones de operaciones
  operacionCs32_33(): void {
    console.log("ini operaciones");
    //casilla 32 se divide en 355 y 356 y se dehabilita 2024
    const cas355 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_355);
    const cas356 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_356);
    const resultadoSuma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas355, cas356, true);
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoSuma, true);
    this.modelo.doc.cuerpo.cs_id_32 = valorRedondeado;

    this.operacionCs270();
    this.operacionCs34();
    this.contarDependientes();
    console.log("fin operaciones");
  }

  operacionCs43_44_45(): void {
    this.operacionCs270();
    this.operacionCs46();
    this.operacionCs298();
    this.contarDependientes();
  }

  operacionCs58_59_60(): void {
    this.operacionCs270();
    this.operacionCs61();
  }

  operacionCs74_75_76(): void {
    this.operacionCs270();
    this.operacionCs78();
  }

  //Otras operaciones de cambio
  ingresoCs121(): void {
    this.calcularCas121 = false;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_121);
    this.modelo.doc.cuerpo.cs_id_121 = valorRedondeado;
    this.operacionCs120();
  }

  cambioUsarioCs127(): void {
    const cas121 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_121, true);
    const cas125 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_125, true);
    const cas126 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_126, true);
    const resultadoResta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, cas121, cas125, true);
    const resultadoOperacion = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultadoResta, "0") ? "0" : resultadoResta;
    const valorRedondeado = this.dutilidades.redondearValorMoneda(resultadoOperacion, true);
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, cas126, resultadoOperacion)) {
      this.modelo.doc.cuerpo.cs_id_126 = valorRedondeado;
      this._notifications.showError("El valor de la casilla 126 no puede ser menor a la casilla 121 - casilla 125");
    }
    this.operacionCs127Cambio();
   // this.operacionCs129();
  }

  operacionCs127Cambio(): void {
    const cas115 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_115);
    const cas127 = this.dutilidades.redondearValorMoneda(this.modelo.doc.cuerpo.cs_id_127);

    let porcentajeTopeMax = "0";
    let porcentajeTopeMin = "0";

      porcentajeTopeMin = "0.14";
      porcentajeTopeMax = "0.2";
    
    const cas115DiezPorciento = this.dutilidades.redondearValorMoneda(this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas115, porcentajeTopeMin));
    const cas115MaxTopePorciento = this.dutilidades.redondearValorMoneda(this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, cas115, porcentajeTopeMax));

    if (!(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_O_IGUAL_QUE, cas127, cas115DiezPorciento) &&
      (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE, cas127, cas115MaxTopePorciento)))) {
      this.modelo.doc.cuerpo.cs_id_127 = cas115MaxTopePorciento;
      this._notifications.showError("El valor de la casilla 127 debe estar en un rango del " + this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, porcentajeTopeMin, "100") + "% al " + this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, porcentajeTopeMax, "100") + "% de la casilla 115");
    }
    this.operacionCs129();
  }
  contarDependientes()
  {
    this.cuentadependientes=0;
    if( this.modelo.doc.cuerpo.cs_id_241 != null && this.modelo.doc.cuerpo.cs_id_242 != null  && this.modelo.doc.cuerpo.cs_id_244 != null &&
      this.modelo.doc.cuerpo.cs_id_241 != "" && this.modelo.doc.cuerpo.cs_id_242 != ""  && this.modelo.doc.cuerpo.cs_id_244 != "" 
      && this.modelo.doc.cuerpo.cs_id_241 != "0" && this.modelo.doc.cuerpo.cs_id_242 != "0"  && this.modelo.doc.cuerpo.cs_id_244 != "0"
      && this.modelo.doc.cuerpo.cs_id_242.length>3)
      {
        this.cuentadependientes++;
      }
    if (this.modelo.doc.cuerpo.cs_id_287 != null && this.modelo.doc.cuerpo.cs_id_288 != null && this.modelo.doc.cuerpo.cs_id_289 != null &&
      this.modelo.doc.cuerpo.cs_id_287 != "" && this.modelo.doc.cuerpo.cs_id_288 != "" && this.modelo.doc.cuerpo.cs_id_289 != ""
      && this.modelo.doc.cuerpo.cs_id_287 != "0" && this.modelo.doc.cuerpo.cs_id_288 != "0" && this.modelo.doc.cuerpo.cs_id_289 != "0"
      && this.modelo.doc.cuerpo.cs_id_288.length>3) 
      {
        this.cuentadependientes++;
      }
    if (this.modelo.doc.cuerpo.cs_id_290 != null && this.modelo.doc.cuerpo.cs_id_291 != null && this.modelo.doc.cuerpo.cs_id_292 != null &&
        this.modelo.doc.cuerpo.cs_id_290 != "" && this.modelo.doc.cuerpo.cs_id_291 != "" && this.modelo.doc.cuerpo.cs_id_292 != ""
        && this.modelo.doc.cuerpo.cs_id_290 != "0" && this.modelo.doc.cuerpo.cs_id_291 != "0" && this.modelo.doc.cuerpo.cs_id_292 != "0"
        && this.modelo.doc.cuerpo.cs_id_291.length>3) 
      {
        
        this.cuentadependientes++;
      }
    if (this.modelo.doc.cuerpo.cs_id_293 != null && this.modelo.doc.cuerpo.cs_id_294 != null && this.modelo.doc.cuerpo.cs_id_295 != null &&
        this.modelo.doc.cuerpo.cs_id_293 != "" && this.modelo.doc.cuerpo.cs_id_294 != "" && this.modelo.doc.cuerpo.cs_id_295 != ""
        && this.modelo.doc.cuerpo.cs_id_293 != "0" && this.modelo.doc.cuerpo.cs_id_294 != "0" && this.modelo.doc.cuerpo.cs_id_295 != "0"
        && this.modelo.doc.cuerpo.cs_id_294.length>3) 
      {
          this.cuentadependientes++;
          
       }
       this.operacionCs139();
  }
  
  asignaCasillaSugerida(objSugerida:any)
  {
    /*objSugerida={
      "data": {
          "id": "9999999999",
          "numDocumento": "98772488",
          "nit": 98772488,
          "ideTipoDocumento": 10910094,
          "tipoDocumento": "C. C.",
          "anoGravable": 2025,
          "nomRazonSocial": null,
          "version": null,
          "formato": null,
          "tope1": 100000000,
          "tope2": 20000000,
          "tope3": 3000000,
          "tope4": 40000000,
          "tope5": 5000000,
          "tope6": null,
          "c297": 19956789.98,
          "c29": 2000000,
          "c30": 4000000,
          "c32": 4000000,
          "c355": 5000000,
          "c33": 6000000,
          "c35": 7000000,
          "c36": 80000000,
          "c43": 9000000,
          "c44": 9000000,
          "c47": 9000000,
          "c51": 9000000,
          "r44": 11111111,
          "c58": 2222222,
          "c59": 333333333,
          "c63": 44444444,
          "c67": 84444444,
          "c74": 555555555,
          "c76": 66666666,
          "c80": 77777777,
          "c84": 77777777,
          "c98": 88888888,
          "c99": 9999999,
          "c100": 123,
          "c102":1000000,
          "c104": 456,
          "c105": 789,
          "c107": 123456789,
          "c302": null,
          "c112": null,
          "c114": null,
          "c122": null,
          "c123": null,
          "c124": null,
          "c130": null,
          "c131": null,
          "c132": null,
          "c245": "1",
          "c246": 9000000,
          "ident": 0,
          "ident1": 0,
          "ident2": 0,
          "ident3": 0,
          "ident4": 0,
          "ident5": 0,
          "ident6": 0,
          "plazo": null,
          "fechaCorte": null
      },
      "respuesta": {
          "codigo": 200,
          "mensaje": "Operación exitosa. ",
          "timestamp": "2025-06-01T16:45:53.045+00:00"
      }
    } */
    let keys = Object.keys(objSugerida.data);
    
    this.declaracionSugerida=new DDeclaracionSugerida(); 
    for (let i in keys) 
    {
      const caracter = keys[i].substring(0,1); 
      const casilla = keys[i]; 
      if (caracter.toString()=== CARACTERSUGERIDA) 
      {
        const casilanumerica=casilla.replace(CARACTERSUGERIDA,'');
        const casillaformulario='cs_id_'+casilanumerica.trim();
        const casillasugerida='valSugeridoCasilla'+casilanumerica;
        const valosCasilla=objSugerida.data[keys[i]] != null 
                      ?objSugerida.data[keys[i]]:'0';
        const valorNumericoCasilla = Number(valosCasilla);
        const valorFormatoMoneda = this.dutilidades.redondearValorMoneda(this.dutilidades.obtenerFormatoMoneda(""+valorNumericoCasilla));
        this.declaracionSugerida[casillasugerida]=valorFormatoMoneda;
        //this.modelo.doc.cuerpo[casillaformulario]=objSugerida.data[keys[i]];
      }
    }
    if(Number(this.declaracionSugerida['valSugeridoCasilla297'])>0)this.modelo.doc.cuerpo.cs_id_299='1';
    if(Number(this.declaracionSugerida['valSugeridoCasilla246'])>0)
    {
      this.modelo.doc.cuerpo.cs_id_245='1';
      this.declaracionSugerida['valSugeridoCasilla245']='1';
    }
    this.declaracionSugerida.ideFormato=FORMATO;
    
    this.declaracionSugerida.anioGravable=objSugerida.data.anoGravable; //this.anioDeclaracion;
    this.declaracionSugerida.numIdentificacion =Number(objSugerida.data.numDocumento);
    this.declaracionSugerida.numVersionFormato =18;
    
    
    
   //this.declaracionSugerida;
  }
ejecutarGuardadoPostRecalculo(definitivo: boolean, validacion:boolean, mensaje: string)
  
{
  const camposSuma = ['cs_id_246', 'cs_id_248', 'cs_id_250', 'cs_id_525', 'cs_id_254', 'cs_id_256', 'cs_id_276', 'cs_id_278', 'cs_id_280', 'cs_id_281'];
    const resultadoSuma = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSuma, true);

    //sumar 31,38,49 y comparar contra suma de preguntas
    const camposSumaIngresos = ['cs_id_32', 'cs_id_43', 'cs_id_58', 'cs_id_74'];
    const resultadoSumaIngresos = this.operarCamposCuerpo(DTipoOperacionAritmetica.SUMA, this.modelo, camposSumaIngresos, true);
    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, resultadoSuma, resultadoSumaIngresos)) {
      mensaje = MESSAGES.SUMATORIA_MAYOR_A_INGRESOS;
      validacion = false;
    }

    const cas41 = this.modelo.doc.cuerpo.cs_id_41;
    const cas53 = this.modelo.doc.cuerpo.cs_id_53;
    const cas69 = this.modelo.doc.cuerpo.cs_id_69;
    const cas86 = this.modelo.doc.cuerpo.cs_id_86;
    const cas37 = this.modelo.doc.cuerpo.cs_id_37;
    const cas40 = this.modelo.doc.cuerpo.cs_id_40;
    const cas49 = this.modelo.doc.cuerpo.cs_id_49;
    const cas52 = this.modelo.doc.cuerpo.cs_id_52;
    const cas65 = this.modelo.doc.cuerpo.cs_id_65;
    const cas68 = this.modelo.doc.cuerpo.cs_id_68;
    const cas82 = this.modelo.doc.cuerpo.cs_id_82;
    const cas85 = this.modelo.doc.cuerpo.cs_id_85;

    const suma37_40 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas37, cas40, true);
    const suma49_52 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas49, cas52, true);
    const suma65_68 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas65, cas68, true);
    const suma82_85 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, cas82, cas85, true);

    this.temporal41 = this.dutilidades.redondearValorMoneda(this.temporal41);
    this.temporal53 = this.dutilidades.redondearValorMoneda(this.temporal53);
    this.temporal69 = this.dutilidades.redondearValorMoneda(this.temporal69);
    this.temporal86 = this.dutilidades.redondearValorMoneda(this.temporal86);

    if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma37_40, "0") && !this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas41, this.temporal41)) {
      mensaje = "Los valores han cambiado. Recalcule el valor de la casilla 41, para hacerlo, ingrese de nuevo el valor de alguna de las casillas 35, 36, 38 o 39. El valor sugerido para la casilla 41 es: " + this.temporal41;
      validacion = false;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma49_52, "0") && !this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas53, this.temporal53)) {
      mensaje = "Los valores han cambiado. Recalcule el valor de la casilla 53, para hacerlo, ingrese de nuevo el valor de alguna de las casillas 47, 48, 50 o 51. El valor sugerido para la casilla 53 es: " + this.temporal53;
      validacion = false;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma65_68, "0") && !this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas69, this.temporal69)) {
      mensaje = "Los valores han cambiado. Recalcule el valor de la casilla 69, para hacerlo, ingrese de nuevo el valor de alguna de las casillas 63, 64, 66 o 67. El valor sugerido para la casilla 69 es: " + this.temporal69;
      validacion = false;
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, suma82_85, "0") && !this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, cas86, this.temporal86)) {
      mensaje = "Los valores han cambiado. Recalcule el valor de la casilla 86, para hacerlo, ingrese de nuevo el valor de alguna de las casillas 80, 81, 83 o 84. El valor sugerido para la casilla 86 es: " + this.temporal86;
      validacion = false;
    }

    this.modelo.doc.cuerpo.cs_id_117 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_117);
    this.modelo.doc.cuerpo.cs_id_118 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_118);
    this.modelo.doc.cuerpo.cs_id_127 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_127);
    this.modelo.doc.cuerpo.cs_id_130 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_130);
    this.modelo.doc.cuerpo.cs_id_271 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_271);
    this.modelo.doc.cuerpo.cs_id_272 = this.dutilidades.deshacerFormatoMoneda(this.modelo.doc.cuerpo.cs_id_272);

    this.modelo.doc.pie.cs_id_980 = this.dutilidades.deshacerFormatoMoneda(this.dutilidades.redondearValorMoneda(this.modelo.doc.pie.cs_id_980));
    
  /*  if(validacion){
      validacion=this.operacionCs358();
      mensaje=MESSAGES.DEPENDIENTE;
    }*/
    this.verificaDisponiblidad();
    if(!this.disponibilidad)
    {
      mensaje = "Este formulario no se encuentra disponible para su diligenciamiento, por favor verifique su acceso";
      validacion = false;
    }
    if (validacion ) {
          this.cambioFirma = false;
          if (definitivo) this.validarDeclaSugeridaGuardarDefinitivo();
          else this.validarDeclaSugeridaGuardar();
    } else this._notifications.showError(mensaje);
}
public verificaDisponiblidad()
  {
     //////Verifica si el formulario es permitido para su diligenciamiento
     if(this.anioDeclaracion <2023 )
     {
       this.disponibilidad=false;
       let error:DError=new DError();
       error.codigo=520;
       error.mensaje='Formulario no disponible para Diligenciamiento';
       error.descripcion='Este formulario no se encuentra disponible para su diligenciamiento, por favor verifique su acceso' 
       let dialogo = this.dNotificacionServicio.mostrarDialogoError(error.mensaje, error.descripcion);
       dialogo.afterClosed().subscribe(res => {
        // window.history.back();
        this._location.back();
     });
     } 
  }
}




// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-experto/formulario/formulario.component.ts